/**
 * Copyright IBM Corp. 2016, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { i as iconPropTypes, _ as _objectWithoutProperties, I as Icon, a as _objectSpread2 } from '../iconPropTypes-44033017.js';
import React from 'react';
import '@carbon/icon-helpers';
import 'prop-types';

var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle3, _path19, _path20, _path21, _path22, _circle4, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _rect, _path42, _path43, _path44, _path45, _circle5, _circle6, _circle7, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208;

var _excluded = ["children", "size"],
    _excluded2 = ["children", "size"],
    _excluded3 = ["children", "size"],
    _excluded4 = ["children", "size"],
    _excluded5 = ["children", "size"],
    _excluded6 = ["children", "size"],
    _excluded7 = ["children", "size"],
    _excluded8 = ["children", "size"],
    _excluded9 = ["children", "size"],
    _excluded10 = ["children", "size"],
    _excluded11 = ["children", "size"],
    _excluded12 = ["children", "size"],
    _excluded13 = ["children", "size"],
    _excluded14 = ["children", "size"],
    _excluded15 = ["children", "size"],
    _excluded16 = ["children", "size"],
    _excluded17 = ["children", "size"],
    _excluded18 = ["children", "size"],
    _excluded19 = ["children", "size"],
    _excluded20 = ["children", "size"],
    _excluded21 = ["children", "size"],
    _excluded22 = ["children", "size"],
    _excluded23 = ["children", "size"],
    _excluded24 = ["children", "size"],
    _excluded25 = ["children", "size"],
    _excluded26 = ["children", "size"],
    _excluded27 = ["children", "size"],
    _excluded28 = ["children", "size"],
    _excluded29 = ["children", "size"],
    _excluded30 = ["children", "size"],
    _excluded31 = ["children", "size"],
    _excluded32 = ["children", "size"],
    _excluded33 = ["children", "size"],
    _excluded34 = ["children", "size"],
    _excluded35 = ["children", "size"],
    _excluded36 = ["children", "size"],
    _excluded37 = ["children", "size"],
    _excluded38 = ["children", "size"],
    _excluded39 = ["children", "size"],
    _excluded40 = ["children", "size"],
    _excluded41 = ["children", "size"],
    _excluded42 = ["children", "size"],
    _excluded43 = ["children", "size"],
    _excluded44 = ["children", "size"],
    _excluded45 = ["children", "size"],
    _excluded46 = ["children", "size"],
    _excluded47 = ["children", "size"],
    _excluded48 = ["children", "size"],
    _excluded49 = ["children", "size"],
    _excluded50 = ["children", "size"],
    _excluded51 = ["children", "size"],
    _excluded52 = ["children", "size"],
    _excluded53 = ["children", "size"],
    _excluded54 = ["children", "size"],
    _excluded55 = ["children", "size"],
    _excluded56 = ["children", "size"],
    _excluded57 = ["children", "size"],
    _excluded58 = ["children", "size"],
    _excluded59 = ["children", "size"],
    _excluded60 = ["children", "size"],
    _excluded61 = ["children", "size"],
    _excluded62 = ["children", "size"],
    _excluded63 = ["children", "size"],
    _excluded64 = ["children", "size"],
    _excluded65 = ["children", "size"],
    _excluded66 = ["children", "size"],
    _excluded67 = ["children", "size"],
    _excluded68 = ["children", "size"],
    _excluded69 = ["children", "size"],
    _excluded70 = ["children", "size"],
    _excluded71 = ["children", "size"],
    _excluded72 = ["children", "size"],
    _excluded73 = ["children", "size"],
    _excluded74 = ["children", "size"],
    _excluded75 = ["children", "size"],
    _excluded76 = ["children", "size"],
    _excluded77 = ["children", "size"],
    _excluded78 = ["children", "size"],
    _excluded79 = ["children", "size"],
    _excluded80 = ["children", "size"],
    _excluded81 = ["children", "size"],
    _excluded82 = ["children", "size"],
    _excluded83 = ["children", "size"],
    _excluded84 = ["children", "size"],
    _excluded85 = ["children", "size"],
    _excluded86 = ["children", "size"],
    _excluded87 = ["children", "size"],
    _excluded88 = ["children", "size"],
    _excluded89 = ["children", "size"],
    _excluded90 = ["children", "size"],
    _excluded91 = ["children", "size"],
    _excluded92 = ["children", "size"],
    _excluded93 = ["children", "size"],
    _excluded94 = ["children", "size"],
    _excluded95 = ["children", "size"],
    _excluded96 = ["children", "size"],
    _excluded97 = ["children", "size"],
    _excluded98 = ["children", "size"],
    _excluded99 = ["children", "size"],
    _excluded100 = ["children", "size"],
    _excluded101 = ["children", "size"],
    _excluded102 = ["children", "size"],
    _excluded103 = ["children", "size"],
    _excluded104 = ["children", "size"],
    _excluded105 = ["children", "size"],
    _excluded106 = ["children", "size"],
    _excluded107 = ["children", "size"],
    _excluded108 = ["children", "size"],
    _excluded109 = ["children", "size"],
    _excluded110 = ["children", "size"],
    _excluded111 = ["children", "size"],
    _excluded112 = ["children", "size"],
    _excluded113 = ["children", "size"],
    _excluded114 = ["children", "size"],
    _excluded115 = ["children", "size"],
    _excluded116 = ["children", "size"],
    _excluded117 = ["children", "size"],
    _excluded118 = ["children", "size"],
    _excluded119 = ["children", "size"],
    _excluded120 = ["children", "size"],
    _excluded121 = ["children", "size"],
    _excluded122 = ["children", "size"],
    _excluded123 = ["children", "size"],
    _excluded124 = ["children", "size"],
    _excluded125 = ["children", "size"];
var TaskLocation = /*#__PURE__*/React.forwardRef(function TaskLocation(_ref, ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 16 : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "21",
    r: "2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,31l-4.7788-6.4019A5.9354,5.9354,0,0,1,18,21a6,6,0,0,1,12,0,5.9407,5.9407,0,0,1-1.2246,3.6028Zm0-14a4.0045,4.0045,0,0,0-4,4,3.9572,3.9572,0,0,0,.82,2.3972L24,27.6567l3.1763-4.2548A3.9627,3.9627,0,0,0,28,21,4.0045,4.0045,0,0,0,24,17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TaskLocation.propTypes = iconPropTypes;
}
var TaskRemove = /*#__PURE__*/React.forwardRef(function TaskRemove(_ref2, ref) {
  var children = _ref2.children,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 16 : _ref2$size,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.41 25L30 21.41 28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3V17h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TaskRemove.propTypes = iconPropTypes;
}
var TaskSettings = /*#__PURE__*/React.forwardRef(function TaskSettings(_ref3, ref) {
  var children = _ref3.children,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 16 : _ref3$size,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v6h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TaskSettings.propTypes = iconPropTypes;
}
var TaskStar = /*#__PURE__*/React.forwardRef(function TaskStar(_ref4, ref) {
  var children = _ref4.children,
      _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 16 : _ref4$size,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23 17L25.23 21.32 30 22 26.5 25.167 28 30 23 27.208 18 30 19.5 25.167 16 22 20.9 21.32 23 17z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v7h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TaskStar.propTypes = iconPropTypes;
}
var TaskTools = /*#__PURE__*/React.forwardRef(function TaskTools(_ref5, ref) {
  var children = _ref5.children,
      _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? 16 : _ref5$size,
      rest = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5,32a3.4762,3.4762,0,0,1-2.4751-1.0254L21.897,26.8469a6.496,6.496,0,0,1-7.3482-8.9563l.5879-1.34L19.293,20.707a1.0234,1.0234,0,0,0,1.4135,0,.999.999,0,0,0,.0005-1.4141l-4.1562-4.1565,1.34-.5881a6.4965,6.4965,0,0,1,8.9566,7.3486l4.1274,4.1282A3.5,3.5,0,0,1,28.5,32Zm-6.03-7.4087,4.9693,4.9692a1.5352,1.5352,0,0,0,2.1211,0,1.4985,1.4985,0,0,0,0-2.1208v0l-4.9692-4.97.188-.5823A4.496,4.496,0,0,0,20.5,16q-.126,0-.25.0068l1.8716,1.8721a2.9992,2.9992,0,0,1,0,4.2424,3.0722,3.0722,0,0,1-4.2427-.0005l-1.8716-1.8715Q16,20.3741,16,20.5A4.4968,4.4968,0,0,0,21.8877,24.78Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h7V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TaskTools.propTypes = iconPropTypes;
}
var TaskView = /*#__PURE__*/React.forwardRef(function TaskView(_ref6, ref) {
  var children = _ref6.children,
      _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? 16 : _ref6$size,
      rest = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "24",
    r: "2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12,28H7V7h3v3H22V7h3v9h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h5ZM12,4h8V8H12Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TaskView.propTypes = iconPropTypes;
}
var Taste = /*#__PURE__*/React.forwardRef(function Taste(_ref7, ref) {
  var children = _ref7.children,
      _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? 16 : _ref7$size,
      rest = _objectWithoutProperties(_ref7, _excluded7);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4V6H8v8a8 8 0 0016 0V6h4V4zM22 14a6 6 0 01-12 0V6h5v8h2V6h5zM11 26H13V28H11zM7 24H9V26H7zM15 24H17V26H15zM19 26H21V28H19zM23 24H25V26H23z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Taste.propTypes = iconPropTypes;
}
var Taxi = /*#__PURE__*/React.forwardRef(function Taxi(_ref8, ref) {
  var children = _ref8.children,
      _ref8$size = _ref8.size,
      size = _ref8$size === void 0 ? 16 : _ref8$size,
      rest = _objectWithoutProperties(_ref8, _excluded8);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.39,16.08,22.7,13.21,20.16,8.87l-.08-.12A2,2,0,0,0,18.52,8h-8a2,2,0,0,0-1.67.89L5.46,14H3a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.39,16.08ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V16H6a1,1,0,0,0,.83-.45L10.54,10h8l2.63,4.5a1,1,0,0,0,.47.42L28,17.66Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Taxi.propTypes = iconPropTypes;
}
var TcpIpService = /*#__PURE__*/React.forwardRef(function TcpIpService(_ref9, ref) {
  var children = _ref9.children,
      _ref9$size = _ref9.size,
      size = _ref9$size === void 0 ? 16 : _ref9$size,
      rest = _objectWithoutProperties(_ref9, _excluded9);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28H30V30H16zM27 26h-8c-1.1028 0-2-.8972-2-2v-5c0-1.1028.8972-2 2-2h8c1.1028 0 2 .8972 2 2v5c0 1.1028-.8972 2-2 2zm-8-7v5h8v-5h-8zM15 23h-5c-1.1028 0-2-.8972-2-2v-4h2v4h5v2zM2 13H16V15H2zM13 11H5c-1.1028 0-2-.8972-2-2V4c0-1.1028.8972-2 2-2H13c1.1028 0 2 .8972 2 2v5c0 1.1028-.8972 2-2 2zM5 4v5H13V4H5z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TcpIpService.propTypes = iconPropTypes;
}
var Temperature = /*#__PURE__*/React.forwardRef(function Temperature(_ref10, ref) {
  var children = _ref10.children,
      _ref10$size = _ref10.size,
      size = _ref10$size === void 0 ? 16 : _ref10$size,
      rest = _objectWithoutProperties(_ref10, _excluded10);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.26V6A4 4 0 005 6V17.26a7 7 0 108 0zM9 4a2 2 0 012 2v7H7V6A2 2 0 019 4zM9 28a5 5 0 01-2.5-9.33l.5-.28V15h4v3.39l.5.28A5 5 0 019 28zM20 4H30V6H20zM20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Temperature.propTypes = iconPropTypes;
}
var TemperatureCelsius = /*#__PURE__*/React.forwardRef(function TemperatureCelsius(_ref11, ref) {
  var children = _ref11.children,
      _ref11$size = _ref11.size,
      size = _ref11$size === void 0 ? 16 : _ref11$size,
      rest = _objectWithoutProperties(_ref11, _excluded11);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30,18H24a2.0023,2.0023,0,0,1-2-2V6a2.002,2.002,0,0,1,2-2h6V6H24V16h6Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "4",
    r: "2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10,20.1841V12H8v8.1841a3,3,0,1,0,2,0Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TemperatureCelsius.propTypes = iconPropTypes;
}
var TemperatureCelsiusAlt = /*#__PURE__*/React.forwardRef(function TemperatureCelsiusAlt(_ref12, ref) {
  var children = _ref12.children,
      _ref12$size = _ref12.size,
      size = _ref12$size === void 0 ? 16 : _ref12$size,
      rest = _objectWithoutProperties(_ref12, _excluded12);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26 27H17a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h9v2H17V25h9zM8 13a4 4 0 114-4h0A4.0118 4.0118 0 018 13zM8 7a2 2 0 102 2h0A2.0059 2.0059 0 008 7z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TemperatureCelsiusAlt.propTypes = iconPropTypes;
}
var TemperatureFahrenheit = /*#__PURE__*/React.forwardRef(function TemperatureFahrenheit(_ref13, ref) {
  var children = _ref13.children,
      _ref13$size = _ref13.size,
      size = _ref13$size === void 0 ? 16 : _ref13$size,
      rest = _objectWithoutProperties(_ref13, _excluded13);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6L30 4 22 4 22 18 24 18 24 12 29 12 29 10 24 10 24 6 30 6z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "4",
    r: "2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10,20.1841V12H8v8.1841a3,3,0,1,0,2,0Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TemperatureFahrenheit.propTypes = iconPropTypes;
}
var TemperatureFahrenheitAlt = /*#__PURE__*/React.forwardRef(function TemperatureFahrenheitAlt(_ref14, ref) {
  var children = _ref14.children,
      _ref14$size = _ref14.size,
      size = _ref14$size === void 0 ? 16 : _ref14$size,
      rest = _objectWithoutProperties(_ref14, _excluded14);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26 11L26 9 15 9 15 27 17 27 17 19 25 19 25 17 17 17 17 11 26 11zM8 13a4 4 0 114-4h0A4.0118 4.0118 0 018 13zM8 7a2 2 0 102 2h0A2.0059 2.0059 0 008 7z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TemperatureFahrenheitAlt.propTypes = iconPropTypes;
}
var TemperatureFeelsLike = /*#__PURE__*/React.forwardRef(function TemperatureFeelsLike(_ref15, ref) {
  var children = _ref15.children,
      _ref15$size = _ref15.size,
      size = _ref15$size === void 0 ? 16 : _ref15$size,
      rest = _objectWithoutProperties(_ref15, _excluded15);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30H22a2.0059 2.0059 0 01-2-2V21a2.0059 2.0059 0 01-2-2V13a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0126 30zM21 12a.9448.9448 0 00-1 1v6h2v9h4V19h2V13a.9448.9448 0 00-1-1zM24 9a4 4 0 114-4h0A4.0118 4.0118 0 0124 9zm0-6a2 2 0 102 2h0a2.0059 2.0059 0 00-2-2zM10 20.1839V12H8v8.1839a3 3 0 102 0z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TemperatureFeelsLike.propTypes = iconPropTypes;
}
var TemperatureFrigid = /*#__PURE__*/React.forwardRef(function TemperatureFrigid(_ref16, ref) {
  var children = _ref16.children,
      _ref16$size = _ref16.size,
      size = _ref16$size === void 0 ? 16 : _ref16$size,
      rest = _objectWithoutProperties(_ref16, _excluded16);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.167 16.89L21.72 13 27.167 9.109 29.684 9.948 30.316 8.051 28 7.279 28 5 26 5 26 7.485 21 11.057 21 5.367 23.555 3.664 22.445 2 20 3.63 17.555 2 16.445 3.664 19 5.367 19 11.057 16 8.914 16 11.372 18.28 13 16 14.628 16 17.086 19 14.943 19 21.703 22.445 24 23.555 22.336 21 20.633 21 14.943 26 18.515 26 21 28 21 28 18.721 30.316 17.948 29.684 16.051 27.167 16.89zM12 23a3 3 0 01-6 0z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TemperatureFrigid.propTypes = iconPropTypes;
}
var TemperatureHot = /*#__PURE__*/React.forwardRef(function TemperatureHot(_ref17, ref) {
  var children = _ref17.children,
      _ref17$size = _ref17.size,
      size = _ref17$size === void 0 ? 16 : _ref17$size,
      rest = _objectWithoutProperties(_ref17, _excluded17);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26 13H30V15H26z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M23.121 5.879H27.121V7.879H23.121z",
    transform: "rotate(-45 25.121 6.879)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M24.121 19.121H26.121V23.121H24.121z",
    transform: "rotate(-45 25.121 21.121)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2H19V6H17zM18 8a6.0365 6.0365 0 00-1 .09v2.0518A3.9567 3.9567 0 0118 10a4 4 0 010 8v2A6 6 0 0018 8zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TemperatureHot.propTypes = iconPropTypes;
}
var TemperatureInversion = /*#__PURE__*/React.forwardRef(function TemperatureInversion(_ref18, ref) {
  var children = _ref18.children,
      _ref18$size = _ref18.size,
      size = _ref18$size === void 0 ? 16 : _ref18$size,
      rest = _objectWithoutProperties(_ref18, _excluded18);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M30 8H24v6h2V11.541A5.939 5.939 0 0128 16a6.0039 6.0039 0 01-5.0945 5.9243A7.0273 7.0273 0 0020 17.2617V6a4 4 0 00-8 0V17.2617a6.996 6.996 0 1010.9292 6.68A7.9794 7.9794 0 0027.2651 10H30zM14 6a2 2 0 014 0v7H14zm2 22a4.9965 4.9965 0 01-2.499-9.3252L14 18.3857V15h4v3.3857l.499.2891A4.9965 4.9965 0 0116 28zM2 10a8.04 8.04 0 002.7349 6H2v2H8V12H6v2.4592A5.94 5.94 0 014 10a6.0066 6.0066 0 016-6V2A8.0092 8.0092 0 002 10z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TemperatureInversion.propTypes = iconPropTypes;
}
var TemperatureMax = /*#__PURE__*/React.forwardRef(function TemperatureMax(_ref19, ref) {
  var children = _ref19.children,
      _ref19$size = _ref19.size,
      size = _ref19$size === void 0 ? 16 : _ref19$size,
      rest = _objectWithoutProperties(_ref19, _excluded19);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10H27V12H20zM20 16H30V18H20zM20 22H27V24H20zM10 20.1839V7H8V20.1839a3 3 0 102 0z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M30,4H12.9744A4.9829,4.9829,0,0,0,4,7V18.1108a7,7,0,1,0,10,0V7a5.0019,5.0019,0,0,0-.1011-1H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TemperatureMax.propTypes = iconPropTypes;
}
var TemperatureMin = /*#__PURE__*/React.forwardRef(function TemperatureMin(_ref20, ref) {
  var children = _ref20.children,
      _ref20$size = _ref20.size,
      size = _ref20$size === void 0 ? 16 : _ref20$size,
      rest = _objectWithoutProperties(_ref20, _excluded20);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H27V6H20zM20 10H30V12H20zM20 16H27V18H20zM12 23a3 3 0 01-6 0z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M30,22H15.9192A7.0107,7.0107,0,0,0,14,18.1108V7A5,5,0,0,0,4,7V18.1108A6.9946,6.9946,0,1,0,15.92,24H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TemperatureMin.propTypes = iconPropTypes;
}
var TemperatureWater = /*#__PURE__*/React.forwardRef(function TemperatureWater(_ref21, ref) {
  var children = _ref21.children,
      _ref21$size = _ref21.size,
      size = _ref21$size === void 0 ? 16 : _ref21$size,
      rest = _objectWithoutProperties(_ref21, _excluded21);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M14,9a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,9V7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,4a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,4a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,7H13V6A4,4,0,0,0,5,6V17.2617A7.0126,7.0126,0,1,0,13.8735,18H14a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,18V16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,13a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,13a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,16H13V9ZM7,6a2,2,0,0,1,4,0v6H7ZM9,28a4.9965,4.9965,0,0,1-2.499-9.3252L7,18.3857V14h4v4.3857l.499.2891A4.9965,4.9965,0,0,1,9,28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TemperatureWater.propTypes = iconPropTypes;
}
var Template = /*#__PURE__*/React.forwardRef(function Template(_ref22, ref) {
  var children = _ref22.children,
      _ref22$size = _ref22.size,
      size = _ref22$size === void 0 ? 16 : _ref22$size,
      rest = _objectWithoutProperties(_ref22, _excluded22);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M26 6v4H6V6H26m0-2H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2zM10 16V26H6V16h4m0-2H6a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V16a2 2 0 00-2-2zM26 16V26H16V16H26m0-2H16a2 2 0 00-2 2V26a2 2 0 002 2H26a2 2 0 002-2V16a2 2 0 00-2-2z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Template.propTypes = iconPropTypes;
}
var Tennis = /*#__PURE__*/React.forwardRef(function Tennis(_ref23, ref) {
  var children = _ref23.children,
      _ref23$size = _ref23.size,
      size = _ref23$size === void 0 ? 16 : _ref23$size,
      rest = _objectWithoutProperties(_ref23, _excluded23);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "4",
    height: "4",
    x: "20",
    y: "2",
    rx: "2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M11,16a1,1,0,0,1-.707-1.707l7-7a1,1,0,1,1,1.414,1.414l-7,7A.9962.9962,0,0,1,11,16Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M23.707,24.293a8.3948,8.3948,0,0,0-4.72-2.209c.1992-.1641.3931-.3364.5777-.521a9.2447,9.2447,0,0,0,1.7334-9.9141l-1.8768.6973c1.11,2.9805.6346,5.8975-1.2722,7.8022a6.6964,6.6964,0,0,1-5.561,1.8047,9.7746,9.7746,0,0,1-5.771-2.7856c-2.9727-2.97-4.0759-8.2276-.9805-11.32,1.9068-1.9053,4.8267-2.38,7.8094-1.271l.6987-1.875C10.6616,3.333,6.8591,3.9961,4.4207,6.4331c-3.9427,3.9385-2.6761,10.4956.98,14.1489a11.8136,11.8136,0,0,0,6.9766,3.36c.21.022.4153.0234.6223.0332V24h4.9968a6.8463,6.8463,0,0,1,4.2962,1.707L26.5859,30,28,28.5859Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Tennis.propTypes = iconPropTypes;
}
var TennisBall = /*#__PURE__*/React.forwardRef(function TennisBall(_ref24, ref) {
  var children = _ref24.children,
      _ref24$size = _ref24.size,
      size = _ref24$size === void 0 ? 16 : _ref24$size,
      rest = _objectWithoutProperties(_ref24, _excluded24);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M19,4a8.9812,8.9812,0,0,0-8.1687,12.7549L2,25.5859,3.4141,27l8.4873-8.4873a9.0408,9.0408,0,0,0,1.5859,1.5859L10,23.5859,11.4141,25l3.8313-3.8311A8.9959,8.9959,0,1,0,19,4Zm6.9058,7.9058a7.005,7.005,0,0,1-5.8116-5.8116A7.005,7.005,0,0,1,25.9058,11.9058ZM12.0942,14.0942a7.005,7.005,0,0,1,5.8116,5.8116A7.005,7.005,0,0,1,12.0942,14.0942ZM19.93,19.9307a9.01,9.01,0,0,0-7.8611-7.8614,7.004,7.004,0,0,1,6-6,9.01,9.01,0,0,0,7.8611,7.8614A7.004,7.004,0,0,1,19.93,19.9307Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TennisBall.propTypes = iconPropTypes;
}
var Term = /*#__PURE__*/React.forwardRef(function Term(_ref25, ref) {
  var children = _ref25.children,
      _ref25$size = _ref25.size,
      size = _ref25$size === void 0 ? 16 : _ref25$size,
      rest = _objectWithoutProperties(_ref25, _excluded25);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H25V24h3V8H25V6h3a2.0023,2.0023,0,0,1,2,2V24A2.0027,2.0027,0,0,1,28,26Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "16",
    r: "2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M7,26H4a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,4,6H7V8H4V24H7Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Term.propTypes = iconPropTypes;
}
var Terminal = /*#__PURE__*/React.forwardRef(function Terminal(_ref26, ref) {
  var children = _ref26.children,
      _ref26$size = _ref26.size,
      size = _ref26$size === void 0 ? 16 : _ref26$size,
      rest = _objectWithoutProperties(_ref26, _excluded26);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z",
    transform: "translate(0 .01)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M10.76 16.18L13.58 19.01 10.76 21.84 12.17 23.25 16.41 19.01 12.17 14.77 10.76 16.18z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Terminal.propTypes = iconPropTypes;
}
var Terminal_3270 = /*#__PURE__*/React.forwardRef(function Terminal_3270(_ref27, ref) {
  var children = _ref27.children,
      _ref27$size = _ref27.size,
      size = _ref27$size === void 0 ? 16 : _ref27$size,
      rest = _objectWithoutProperties(_ref27, _excluded27);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21H16V23H10z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Terminal_3270.propTypes = iconPropTypes;
}
var TestTool = /*#__PURE__*/React.forwardRef(function TestTool(_ref28, ref) {
  var children = _ref28.children,
      _ref28$size = _ref28.size,
      size = _ref28$size === void 0 ? 16 : _ref28$size,
      rest = _objectWithoutProperties(_ref28, _excluded28);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M23 9.2L20.4 6.6 19 8 23 12 30 5 28.6 3.6zM12 5.4L10.6 4 8 6.6 5.4 4 4 5.4 6.6 8 4 10.6 5.4 12 8 9.4 10.6 12 12 10.6 9.4 8zM12 21.4L10.6 20 8 22.6 5.4 20 4 21.4 6.6 24 4 26.6 5.4 28 8 25.4 10.6 28 12 26.6 9.4 24z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15L17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TestTool.propTypes = iconPropTypes;
}
var TextAlignCenter = /*#__PURE__*/React.forwardRef(function TextAlignCenter(_ref29, ref) {
  var children = _ref29.children,
      _ref29$size = _ref29.size,
      size = _ref29$size === void 0 ? 16 : _ref29$size,
      rest = _objectWithoutProperties(_ref29, _excluded29);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H26V8H6zM10 12H22V14H10zM6 18H26V20H6zM10 24H22V26H10z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextAlignCenter.propTypes = iconPropTypes;
}
var TextAlignJustify = /*#__PURE__*/React.forwardRef(function TextAlignJustify(_ref30, ref) {
  var children = _ref30.children,
      _ref30$size = _ref30.size,
      size = _ref30$size === void 0 ? 16 : _ref30$size,
      rest = _objectWithoutProperties(_ref30, _excluded30);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H26V8H6zM6 12H26V14H6zM6 18H26V20H6zM6 24H26V26H6z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextAlignJustify.propTypes = iconPropTypes;
}
var TextAlignLeft = /*#__PURE__*/React.forwardRef(function TextAlignLeft(_ref31, ref) {
  var children = _ref31.children,
      _ref31$size = _ref31.size,
      size = _ref31$size === void 0 ? 16 : _ref31$size,
      rest = _objectWithoutProperties(_ref31, _excluded31);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H26V8H12zM12 12H22V14H12zM12 18H26V20H12zM12 24H22V26H12zM6 4H8V28H6z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextAlignLeft.propTypes = iconPropTypes;
}
var TextAlignMixed = /*#__PURE__*/React.forwardRef(function TextAlignMixed(_ref32, ref) {
  var children = _ref32.children,
      _ref32$size = _ref32.size,
      size = _ref32$size === void 0 ? 16 : _ref32$size,
      rest = _objectWithoutProperties(_ref32, _excluded32);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H9V6h5V8H10a2 2 0 00-2 2v2a2 2 0 002 2h6V6A2.0023 2.0023 0 0014 4zm0 8H10V10h4zM22 26L22 18 20 18 20 19 18 19 18 21 20 21 20 26 18 26 18 28 24 28 24 26 22 26zM2 2H4V16H2zM28 16H30V30H28z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextAlignMixed.propTypes = iconPropTypes;
}
var TextAlignRight = /*#__PURE__*/React.forwardRef(function TextAlignRight(_ref33, ref) {
  var children = _ref33.children,
      _ref33$size = _ref33.size,
      size = _ref33$size === void 0 ? 16 : _ref33$size,
      rest = _objectWithoutProperties(_ref33, _excluded33);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H20V8H6zM10 12H20V14H10zM6 18H20V20H6zM10 24H20V26H10zM24 4H26V28H24z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextAlignRight.propTypes = iconPropTypes;
}
var TextAllCaps = /*#__PURE__*/React.forwardRef(function TextAllCaps(_ref34, ref) {
  var children = _ref34.children,
      _ref34$size = _ref34.size,
      size = _ref34$size === void 0 ? 16 : _ref34$size,
      rest = _objectWithoutProperties(_ref34, _excluded34);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8L1 10 7 10 7 24 9 24 9 10 15 10 15 8 1 8zM17 8L17 10 23 10 23 24 25 24 25 10 31 10 31 8 17 8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextAllCaps.propTypes = iconPropTypes;
}
var TextBold = /*#__PURE__*/React.forwardRef(function TextBold(_ref35, ref) {
  var children = _ref35.children,
      _ref35$size = _ref35.size,
      size = _ref35$size === void 0 ? 16 : _ref35$size,
      rest = _objectWithoutProperties(_ref35, _excluded35);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25,25H9V7h8.5a5.25,5.25,0,0,1,4,8.65A5.25,5.25,0,0,1,18.25,25ZM12,22h6.23a2.25,2.25,0,1,0,0-4.5H12Zm0-7.5h5.5a2.25,2.25,0,1,0,0-4.5H12Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextBold.propTypes = iconPropTypes;
}
var TextClearFormat = /*#__PURE__*/React.forwardRef(function TextClearFormat(_ref36, ref) {
  var children = _ref36.children,
      _ref36$size = _ref36.size,
      size = _ref36$size === void 0 ? 16 : _ref36$size,
      rest = _objectWithoutProperties(_ref36, _excluded36);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4384,16.5715l-7.985-7.9856a2.0014,2.0014,0,0,0-2.8291,0l-5.3584,5.3584L9,2H7L2,16H4l.999-3h6l.8035,2.4077L4.5858,22.6244a2,2,0,0,0,0,2.8282L9.1316,30h9.5908l10.716-10.717A1.9173,1.9173,0,0,0,29.4384,16.5715ZM5.6653,11l2.331-7,2.3355,7Zm12.229,17H9.96L6,24.0381l6.3123-6.3115L20.24,25.6538Zm3.76-3.76-7.9275-7.9272L20.0393,10l7.9268,7.9272Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextClearFormat.propTypes = iconPropTypes;
}
var TextColor = /*#__PURE__*/React.forwardRef(function TextColor(_ref37, ref) {
  var children = _ref37.children,
      _ref37$size = _ref37.size,
      size = _ref37$size === void 0 ? 16 : _ref37$size,
      rest = _objectWithoutProperties(_ref37, _excluded37);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21h2L17 4H15L8 21h2l1.61-4h8.74zm-9.57-6l3.44-8.37h.26L19.54 15zM6 24H26V28H6z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextColor.propTypes = iconPropTypes;
}
var TextCreation = /*#__PURE__*/React.forwardRef(function TextCreation(_ref38, ref) {
  var children = _ref38.children,
      _ref38$size = _ref38.size,
      size = _ref38$size === void 0 ? 16 : _ref38$size,
      rest = _objectWithoutProperties(_ref38, _excluded38);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22.14V9.86A4,4,0,1,0,22.14,5H9.86A4,4,0,1,0,5,9.86V22.14A4,4,0,1,0,9.86,27H22.14A4,4,0,1,0,27,22.14ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm16.14-3H9.86A4,4,0,0,0,7,22.14V9.86A4,4,0,0,0,9.86,7H22.14A4,4,0,0,0,25,9.86V22.14A4,4,0,0,0,22.14,25ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11L11 11 11 13 15 13 15 22 17 22 17 13 21 13 21 11z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextCreation.propTypes = iconPropTypes;
}
var TextFill = /*#__PURE__*/React.forwardRef(function TextFill(_ref39, ref) {
  var children = _ref39.children,
      _ref39$size = _ref39.size,
      size = _ref39$size === void 0 ? 16 : _ref39$size,
      rest = _objectWithoutProperties(_ref39, _excluded39);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H28V30H4z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14.54a1,1,0,0,0-.25-.69L17.17,4.33A1.09,1.09,0,0,0,17,4.2V2H15V5L4.32,14.74a1,1,0,0,0-.06,1.41l8.57,9.52a1,1,0,0,0,.69.33h.05a1,1,0,0,0,.68-.26L24,16.8V21a1,1,0,0,0,2,0V14.57S26,14.55,26,14.54Zm-12.35,9-7.23-8L15,7.67V12h2V7.13l6.59,7.33Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextFill.propTypes = iconPropTypes;
}
var TextFont = /*#__PURE__*/React.forwardRef(function TextFont(_ref40, ref) {
  var children = _ref40.children,
      _ref40$size = _ref40.size,
      size = _ref40$size === void 0 ? 16 : _ref40$size,
      rest = _objectWithoutProperties(_ref40, _excluded40);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12H20v2h5a1.0008 1.0008 0 011 1v2H22a3.0033 3.0033 0 00-3 3v1a3.0033 3.0033 0 003 3h6V15A3.0033 3.0033 0 0025 12zM22 22a1.0008 1.0008 0 01-1-1V20a1.0008 1.0008 0 011-1h4v3zM16 24h2L12 7H10L4 24H6l1.6936-5h6.6135zM8.3711 17l2.4966-7.3711.2668.0005L13.63 17z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextFont.propTypes = iconPropTypes;
}
var TextFootnote = /*#__PURE__*/React.forwardRef(function TextFootnote(_ref41, ref) {
  var children = _ref41.children,
      _ref41$size = _ref41.size,
      size = _ref41$size === void 0 ? 16 : _ref41$size,
      rest = _objectWithoutProperties(_ref41, _excluded41);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7L2 9 9 9 9 25 11 25 11 9 18 9 18 7 2 7zM30 11.076L29.256 9.219 26 10.522 26 7 24 7 24 10.523 20.744 9.22 20 11.077 23.417 12.444 20.9 15.8 22.5 17 25 13.667 27.5 17 29.1 15.8 26.583 12.443 30 11.076z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextFootnote.propTypes = iconPropTypes;
}
var TextHighlight = /*#__PURE__*/React.forwardRef(function TextHighlight(_ref42, ref) {
  var children = _ref42.children,
      _ref42$size = _ref42.size,
      size = _ref42$size === void 0 ? 16 : _ref42$size,
      rest = _objectWithoutProperties(_ref42, _excluded42);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15H5a3 3 0 01-3-3V10A3 3 0 015 7h5V5A1 1 0 009 4H3V2H9a3 3 0 013 3zM5 9a1 1 0 00-1 1v2a1 1 0 001 1h5V9zM20 23v2a1 1 0 001 1h5V22H21A1 1 0 0020 23z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M2,30H30V2Zm26-2H21a3,3,0,0,1-3-3V23a3,3,0,0,1,3-3h5V18a1,1,0,0,0-1-1H19V15h6a3,3,0,0,1,3,3Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextHighlight.propTypes = iconPropTypes;
}
var TextIndent = /*#__PURE__*/React.forwardRef(function TextIndent(_ref43, ref) {
  var children = _ref43.children,
      _ref43$size = _ref43.size,
      size = _ref43$size === void 0 ? 16 : _ref43$size,
      rest = _objectWithoutProperties(_ref43, _excluded43);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6H28V8H14zM14 12H28V14H14zM7 18H28V20H7zM7 24H28V26H7zM4 13.59L7.29 10 4 6.41 5.42 5 10.04 10 5.42 15 4 13.59z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextIndent.propTypes = iconPropTypes;
}
var TextIndentLess = /*#__PURE__*/React.forwardRef(function TextIndentLess(_ref44, ref) {
  var children = _ref44.children,
      _ref44$size = _ref44.size,
      size = _ref44$size === void 0 ? 16 : _ref44$size,
      rest = _objectWithoutProperties(_ref44, _excluded44);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H12V8H2zM5 12H12V14H5zM2 18H12V20H2zM5 24H12V26H5zM16 4H18V28H16zM28.15 23.5L29.56 22.12 23.27 16 29.56 9.88 28.15 8.5 20.44 16 28.15 23.5z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextIndentLess.propTypes = iconPropTypes;
}
var TextIndentMore = /*#__PURE__*/React.forwardRef(function TextIndentMore(_ref45, ref) {
  var children = _ref45.children,
      _ref45$size = _ref45.size,
      size = _ref45$size === void 0 ? 16 : _ref45$size,
      rest = _objectWithoutProperties(_ref45, _excluded45);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H30V8H20zM20 12H27V14H20zM20 18H30V20H20zM20 24H27V26H20zM14 4H16V28H14zM3.85 22.5L2.44 21.12 8.73 15 2.44 8.88 3.85 7.5 11.56 15 3.85 22.5z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextIndentMore.propTypes = iconPropTypes;
}
var TextItalic = /*#__PURE__*/React.forwardRef(function TextItalic(_ref46, ref) {
  var children = _ref46.children,
      _ref46$size = _ref46.size,
      size = _ref46$size === void 0 ? 16 : _ref46$size,
      rest = _objectWithoutProperties(_ref46, _excluded46);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M25 9L25 7 12 7 12 9 17.14 9 12.77 23 7 23 7 25 20 25 20 23 14.86 23 19.23 9 25 9z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextItalic.propTypes = iconPropTypes;
}
var TextKerning = /*#__PURE__*/React.forwardRef(function TextKerning(_ref47, ref) {
  var children = _ref47.children,
      _ref47$size = _ref47.size,
      size = _ref47$size === void 0 ? 16 : _ref47$size,
      rest = _objectWithoutProperties(_ref47, _excluded47);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24L18.83 24 21.12 21.71 19.71 20.29 15 25 19.71 29.71 21.12 28.29 18.83 26 30 26 30 24zM14 21L20 4 18 4 12 21 14 21zM13 4L9 16 5 4 3 4 8 18 10 18 15 4 13 4zM28 18h2L25 4H23L18 18h2l1-3h6zm-6.33-5L24 6l2.33 7z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextKerning.propTypes = iconPropTypes;
}
var TextLeading = /*#__PURE__*/React.forwardRef(function TextLeading(_ref48, ref) {
  var children = _ref48.children,
      _ref48$size = _ref48.size,
      size = _ref48$size === void 0 ? 16 : _ref48$size,
      rest = _objectWithoutProperties(_ref48, _excluded48);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13H30V15H14zM15 28H30V30H15zM25.85 27H28L23.64 17H21.36L17 27h2.15l.8-2h5.1zm-5.1-4l1.75-4.37L24.25 23zM25.85 12H28L23.64 2H21.36L17 12h2.15l.8-2h5.1zm-5.1-4L22.5 3.63 24.25 8zM6 15.83L8.58 18.41 10 17 6 13 2 17 3.41 18.42 6 15.83zM6 27.17L3.42 24.59 2 26 6 30 10 26 8.59 24.58 6 27.17z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextLeading.propTypes = iconPropTypes;
}
var TextLineSpacing = /*#__PURE__*/React.forwardRef(function TextLineSpacing(_ref49, ref) {
  var children = _ref49.children,
      _ref49$size = _ref49.size,
      size = _ref49$size === void 0 ? 16 : _ref49$size,
      rest = _objectWithoutProperties(_ref49, _excluded49);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6H30V8H17zM17 12H27V14H17zM17 18H30V20H17zM17 24H27V26H17zM11.59 13.41L8 9.83 8 9.83 4.41 13.42 3 12 8 7 13 12 11.59 13.41zM11.59 18.59L8 22.17 8 22.17 4.41 18.58 3 20 8 25 13 20 11.59 18.59z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextLineSpacing.propTypes = iconPropTypes;
}
var TextNewLine = /*#__PURE__*/React.forwardRef(function TextNewLine(_ref50, ref) {
  var children = _ref50.children,
      _ref50$size = _ref50.size,
      size = _ref50$size === void 0 ? 16 : _ref50$size,
      rest = _objectWithoutProperties(_ref50, _excluded50);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5859,14.4141,24.1719,18H6V8H4V18a2.0024,2.0024,0,0,0,2,2H24.1719L20.586,23.5859,22,25l6-6-6-6Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextNewLine.propTypes = iconPropTypes;
}
var TextScale = /*#__PURE__*/React.forwardRef(function TextScale(_ref51, ref) {
  var children = _ref51.children,
      _ref51$size = _ref51.size,
      size = _ref51$size === void 0 ? 16 : _ref51$size,
      rest = _objectWithoutProperties(_ref51, _excluded51);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M30 5L30 8 22 8 22 26 19 26 19 8 11 8 11 5 30 5z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M7 26L7 14 2 14 2 12 14 12 14 14 9 14 9 26 7 26z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextScale.propTypes = iconPropTypes;
}
var TextSelection = /*#__PURE__*/React.forwardRef(function TextSelection(_ref52, ref) {
  var children = _ref52.children,
      _ref52$size = _ref52.size,
      size = _ref52$size === void 0 ? 16 : _ref52$size,
      rest = _objectWithoutProperties(_ref52, _excluded52);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M28 27H21a3 3 0 01-3-3V22a3 3 0 013-3h5V17a1 1 0 00-1-1H19V14h6a3 3 0 013 3zm-7-6a1 1 0 00-1 1v2a1 1 0 001 1h5V21zM13 7h3V5H13a4 4 0 00-3 1.38A4 4 0 007 5H4V7H7A2 2 0 019 9v5H5v2H9v7a2 2 0 01-2 2H4v2H7a4 4 0 003-1.38A4 4 0 0013 27h3V25H13a2 2 0 01-2-2V16h4V14H11V9A2 2 0 0113 7z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextSelection.propTypes = iconPropTypes;
}
var TextSmallCaps = /*#__PURE__*/React.forwardRef(function TextSmallCaps(_ref53, ref) {
  var children = _ref53.children,
      _ref53$size = _ref53.size,
      size = _ref53$size === void 0 ? 16 : _ref53$size,
      rest = _objectWithoutProperties(_ref53, _excluded53);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27L23 15 18 15 18 13 30 13 30 15 25 15 25 27 23 27z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M11 27L11 8 2 8 2 6 22 6 22 8 13 8 13 27 11 27z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextSmallCaps.propTypes = iconPropTypes;
}
var TextStrikethrough = /*#__PURE__*/React.forwardRef(function TextStrikethrough(_ref54, ref) {
  var children = _ref54.children,
      _ref54$size = _ref54.size,
      size = _ref54$size === void 0 ? 16 : _ref54$size,
      rest = _objectWithoutProperties(_ref54, _excluded54);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M28,15H17.9563c-.4522-.1237-.9037-.2324-1.3381-.3352-2.8077-.6641-4.396-1.1506-4.396-3.4231a2.8684,2.8684,0,0,1,.7866-2.145,4.7888,4.7888,0,0,1,3.0137-1.09c2.8291-.07,4.1347.8894,5.2011,2.35l1.6153-1.1792a7.4727,7.4727,0,0,0-6.83-3.1706,6.7726,6.7726,0,0,0-4.4,1.6611,4.8274,4.8274,0,0,0-1.3862,3.5735A4.3723,4.3723,0,0,0,11.9573,15H4v2H17.6519c1.9668.57,3.1432,1.3123,3.1733,3.3579a3.119,3.119,0,0,1-.8623,2.3931A5.8241,5.8241,0,0,1,16.2432,24a6.6344,6.6344,0,0,1-5.1451-2.6912L9.5649,22.593A8.5262,8.5262,0,0,0,16.2119,26c.0088-.0012.042,0,.1,0A7.67,7.67,0,0,0,21.36,24.1812a5.0779,5.0779,0,0,0,1.4648-3.8531A4.952,4.952,0,0,0,21.6753,17H28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextStrikethrough.propTypes = iconPropTypes;
}
var TextSubscript = /*#__PURE__*/React.forwardRef(function TextSubscript(_ref55, ref) {
  var children = _ref55.children,
      _ref55$size = _ref55.size,
      size = _ref55$size === void 0 ? 16 : _ref55$size,
      rest = _objectWithoutProperties(_ref55, _excluded55);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M26 25L20 25 20 19 24 19 24 17 20 17 20 15 26 15 26 21 22 21 22 23 26 23 26 25zM5 7L5 9 12 9 12 25 14 25 14 9 21 9 21 7 5 7z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextSubscript.propTypes = iconPropTypes;
}
var TextSuperscript = /*#__PURE__*/React.forwardRef(function TextSuperscript(_ref56, ref) {
  var children = _ref56.children,
      _ref56$size = _ref56.size,
      size = _ref56$size === void 0 ? 16 : _ref56$size,
      rest = _objectWithoutProperties(_ref56, _excluded56);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M29 17L23 17 23 11 27 11 27 9 23 9 23 7 29 7 29 13 25 13 25 15 29 15 29 17zM4 7L4 9 11 9 11 25 13 25 13 9 20 9 20 7 4 7z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextSuperscript.propTypes = iconPropTypes;
}
var TextTracking = /*#__PURE__*/React.forwardRef(function TextTracking(_ref57, ref) {
  var children = _ref57.children,
      _ref57$size = _ref57.size,
      size = _ref57$size === void 0 ? 16 : _ref57$size,
      rest = _objectWithoutProperties(_ref57, _excluded57);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M25.29 19.29L23.88 20.71 26.17 23 5.83 23 8.12 20.71 6.71 19.29 2 24 6.71 28.71 8.12 27.29 5.83 25 26.17 25 23.88 27.29 25.29 28.71 30 24 25.29 19.29zM26 17h2L23 3H21L16 17h2l1-3h6zm-6.33-5L22 5l2.33 7zM14 3L10 15 6 3 4 3 9 17 11 17 16 3 14 3z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextTracking.propTypes = iconPropTypes;
}
var TextUnderline = /*#__PURE__*/React.forwardRef(function TextUnderline(_ref58, ref) {
  var children = _ref58.children,
      _ref58$size = _ref58.size,
      size = _ref58$size === void 0 ? 16 : _ref58$size,
      rest = _objectWithoutProperties(_ref58, _excluded58);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H28V28H4zM16 23a7 7 0 01-7-7V5h2V16a5 5 0 0010 0V5h2V16A7 7 0 0116 23z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextUnderline.propTypes = iconPropTypes;
}
var TextVerticalAlignment = /*#__PURE__*/React.forwardRef(function TextVerticalAlignment(_ref59, ref) {
  var children = _ref59.children,
      _ref59$size = _ref59.size,
      size = _ref59$size === void 0 ? 16 : _ref59$size,
      rest = _objectWithoutProperties(_ref59, _excluded59);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28H30V30H16zM16 23H30V25H16zM10.8458 30H13L8.64 20H6.36L2 30H4.1542l.8-2h5.0916zM5.7541 26L7.5 21.6347 9.2459 26zM2 15H30V17H2zM16 7H30V9H16zM16 2H30V4H16zM10.8458 12H13L8.64 2H6.36L2 12H4.1542l.8-2h5.0916zM5.7541 8L7.5 3.6347 9.2459 8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextVerticalAlignment.propTypes = iconPropTypes;
}
var TextWrap = /*#__PURE__*/React.forwardRef(function TextWrap(_ref60, ref) {
  var children = _ref60.children,
      _ref60$size = _ref60.size,
      size = _ref60$size === void 0 ? 16 : _ref60$size,
      rest = _objectWithoutProperties(_ref60, _excluded60);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M4 23H12V25H4zM24.5232 14H4v2H24.5a3.5 3.5 0 010 7H18.8281l2.586-2.5859L20 19l-5 5 5 5 1.4141-1.4141L18.8281 25H24.533a5.5 5.5 0 00-.01-11zM4 5H28V7H4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextWrap.propTypes = iconPropTypes;
}
var WatsonHealthTextAnnotationToggle = /*#__PURE__*/React.forwardRef(function WatsonHealthTextAnnotationToggle(_ref61, ref) {
  var children = _ref61.children,
      _ref61$size = _ref61.size,
      size = _ref61$size === void 0 ? 16 : _ref61$size,
      rest = _objectWithoutProperties(_ref61, _excluded61);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M29.537 13.76L26.24 10.463a1.5862 1.5862 0 00-2.24 0L10 24.4674V30h5.5326L29.537 16a1.5862 1.5862 0 000-2.24zM14.7042 28H12V25.2958l9.4409-9.4409 2.7042 2.7042zM25.5591 17.145L22.855 14.4409l2.2672-2.2672 2.7042 2.7042zM11 17L13 17 13 10 16 10 16 8 8 8 8 10 11 10 11 17z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M8,20H4V4H20V8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H8Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthTextAnnotationToggle.propTypes = iconPropTypes;
}
var TextLink = /*#__PURE__*/React.forwardRef(function TextLink(_ref62, ref) {
  var children = _ref62.children,
      _ref62$size = _ref62.size,
      size = _ref62$size === void 0 ? 16 : _ref62$size,
      rest = _objectWithoutProperties(_ref62, _excluded62);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7061,27.585a5.2615,5.2615,0,0,1-3.7227-8.9834l1.415,1.414a3.2638,3.2638,0,1,0,4.6153,4.6162l6.03-6.03a3.264,3.264,0,0,0-4.6162-4.6158l-1.414-1.414a5.2637,5.2637,0,0,1,7.4443,7.4438l-6.03,6.03A5.2461,5.2461,0,0,1,18.7061,27.585Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2642 29.9971A5.2619 5.2619 0 016.542 21.0137l6.03-6.03a5.2636 5.2636 0 117.4438 7.4438l-1.414-1.414a3.2639 3.2639 0 10-4.6158-4.6158l-6.03 6.03a3.264 3.264 0 004.6157 4.6162l1.414 1.4141A5.2452 5.2452 0 0110.2642 29.9971zM2 10H10V12H2zM2 6H14V8H2zM2 2H14V4H2z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextLink.propTypes = iconPropTypes;
}
var TextLinkAnalysis = /*#__PURE__*/React.forwardRef(function TextLinkAnalysis(_ref63, ref) {
  var children = _ref63.children,
      _ref63$size = _ref63.size,
      size = _ref63$size === void 0 ? 16 : _ref63$size,
      rest = _objectWithoutProperties(_ref63, _excluded63);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H16V12H8zM8 6H20V8H8zM8 2H20V4H8z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7111,28l5.6312-9.9961,7.4341,6.49A2,2,0,0,0,20.86,23.96l6.9707-10.4034-1.6622-1.1132-7,10.4472-.07.1035-7.4345-6.4907a2.0032,2.0032,0,0,0-3.0806.5308L4,25.1826V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextLinkAnalysis.propTypes = iconPropTypes;
}
var TextMining = /*#__PURE__*/React.forwardRef(function TextMining(_ref64, ref) {
  var children = _ref64.children,
      _ref64$size = _ref64.size,
      size = _ref64$size === void 0 ? 16 : _ref64$size,
      rest = _objectWithoutProperties(_ref64, _excluded64);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M18 28H26V30H18zM18 24H30V26H18zM18 20H30V22H18z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M16.001 26.473L16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextMining.propTypes = iconPropTypes;
}
var TextMiningApplier = /*#__PURE__*/React.forwardRef(function TextMiningApplier(_ref65, ref) {
  var children = _ref65.children,
      _ref65$size = _ref65.size,
      size = _ref65$size === void 0 ? 16 : _ref65$size,
      rest = _objectWithoutProperties(_ref65, _excluded65);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M16.001 26.473L16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19L27 24 20 29 20 19z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TextMiningApplier.propTypes = iconPropTypes;
}
var Theater = /*#__PURE__*/React.forwardRef(function Theater(_ref66, ref) {
  var children = _ref66.children,
      _ref66$size = _ref66.size,
      size = _ref66$size === void 0 ? 16 : _ref66$size,
      rest = _objectWithoutProperties(_ref66, _excluded66);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0120 25zM24 14a2 2 0 102 2A1.9806 1.9806 0 0024 14zM16 14a2 2 0 102 2A1.9806 1.9806 0 0016 14z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V14a10.01,10.01,0,0,0,8.8027,9.9214A9.9989,9.9989,0,0,0,30,20V10A2.0023,2.0023,0,0,0,28,8ZM4,14V4H20V8H12a2.0023,2.0023,0,0,0-2,2V20a9.9628,9.9628,0,0,0,.168,1.78A8.0081,8.0081,0,0,1,4,14Zm24,6a8,8,0,0,1-16,0V10H28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Theater.propTypes = iconPropTypes;
}
var ThisSideUp = /*#__PURE__*/React.forwardRef(function ThisSideUp(_ref67, ref) {
  var children = _ref67.children,
      _ref67$size = _ref67.size,
      size = _ref67$size === void 0 ? 16 : _ref67$size,
      rest = _objectWithoutProperties(_ref67, _excluded67);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2zM7 5.828L7 24 9 24 9 5.828 12.586 9.414 14 8 8 2 2 8 3.414 9.414 7 5.828zM23 5.828L23 24 25 24 25 5.828 28.586 9.414 30 8 24 2 18 8 19.414 9.414 23 5.828z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ThisSideUp.propTypes = iconPropTypes;
}
var WatsonHealthThreshold = /*#__PURE__*/React.forwardRef(function WatsonHealthThreshold(_ref68, ref) {
  var children = _ref68.children,
      _ref68$size = _ref68.size,
      size = _ref68$size === void 0 ? 16 : _ref68$size,
      rest = _objectWithoutProperties(_ref68, _excluded68);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM6,6H26V16H24v2h2v2H24v2h2v2H24v2H22V24H20v2H18V24H16v2H14V24H12v2H10V24H8v2H6Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20H10V22H8zM12 20H14V22H12zM16 20H18V22H16zM20 20H22V22H20zM8 16H10V18H8zM16 16H18V18H16zM20 16H22V18H20zM20 12H22V14H20zM20 8H22V10H20z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthThreshold.propTypes = iconPropTypes;
}
var Thumbnail_1 = /*#__PURE__*/React.forwardRef(function Thumbnail_1(_ref69, ref) {
  var children = _ref69.children,
      _ref69$size = _ref69.size,
      size = _ref69$size === void 0 ? 16 : _ref69$size,
      rest = _objectWithoutProperties(_ref69, _excluded69);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30H4a2 2 0 01-2-2V24a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 30zM4 24v4H8V24zM18 30H14a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 30zm-4-6v4h4V24zM28 30H24a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 30zm-4-6v4h4V24zM28 20H4a2 2 0 01-2-2V4A2 2 0 014 2H28a2 2 0 012 2V18A2 2 0 0128 20zM4 4V18H28V4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Thumbnail_1.propTypes = iconPropTypes;
}
var Thumbnail_2 = /*#__PURE__*/React.forwardRef(function Thumbnail_2(_ref70, ref) {
  var children = _ref70.children,
      _ref70$size = _ref70.size,
      size = _ref70$size === void 0 ? 16 : _ref70$size,
      rest = _objectWithoutProperties(_ref70, _excluded70);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30H4a2 2 0 01-2-2V24a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 30zM4 24v4H8V24zM18 30H14a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 30zm-4-6v4h4V24zM28 30H24a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 30zm-4-6v4h4V24zM8 20H4a2 2 0 01-2-2V14a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 20zM4 14v4H8V14zM18 20H14a2 2 0 01-2-2V14a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 20zm-4-6v4h4V14zM28 20H24a2 2 0 01-2-2V14a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 20zm-4-6v4h4V14zM8 10H4A2 2 0 012 8V4A2 2 0 014 2H8a2 2 0 012 2V8A2 2 0 018 10zM4 4V8H8V4zM18 10H14a2 2 0 01-2-2V4a2 2 0 012-2h4a2 2 0 012 2V8A2 2 0 0118 10zM14 4V8h4V4zM28 10H24a2 2 0 01-2-2V4a2 2 0 012-2h4a2 2 0 012 2V8A2 2 0 0128 10zM24 4V8h4V4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Thumbnail_2.propTypes = iconPropTypes;
}
var WatsonHealthThumbnailPreview = /*#__PURE__*/React.forwardRef(function WatsonHealthThumbnailPreview(_ref71, ref) {
  var children = _ref71.children,
      _ref71$size = _ref71.size,
      size = _ref71$size === void 0 ? 16 : _ref71$size,
      rest = _objectWithoutProperties(_ref71, _excluded71);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H4a2.0023,2.0023,0,0,0-2,2V28a2.002,2.002,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V14A2.0027,2.0027,0,0,0,28,12ZM20,28H12V27a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1Zm8,0H22V27a3.0033,3.0033,0,0,0-3-3H13a3.0033,3.0033,0,0,0-3,3v1H4V14H28.002Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23a4 4 0 114-4A4.0042 4.0042 0 0116 23zm0-6a2 2 0 102 2A2.0023 2.0023 0 0016 17zM30 4V8a2.0027 2.0027 0 01-2 2H24a2.0027 2.0027 0 01-2-2V4a2.0027 2.0027 0 012-2h4A2.0027 2.0027 0 0130 4zM28 8l.002-4H24V8zM20 4V8a2.0027 2.0027 0 01-2 2H14a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h4A2.0027 2.0027 0 0120 4zM18 8l.002-4H14V8zM10 4V8a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 8V4A2.0023 2.0023 0 014 2H8A2.0023 2.0023 0 0110 4zM8 8l.0015-4H4V8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthThumbnailPreview.propTypes = iconPropTypes;
}
var ThumbsDown = /*#__PURE__*/React.forwardRef(function ThumbsDown(_ref72, ref) {
  var children = _ref72.children,
      _ref72$size = _ref72.size,
      size = _ref72$size === void 0 ? 16 : _ref72$size,
      rest = _objectWithoutProperties(_ref72, _excluded72);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16V9a7.0078,7.0078,0,0,0-7-7H2V16H8.4648l3.5774,5.3662.8453,5.9165A2.0094,2.0094,0,0,0,14.8672,29H17a3.0033,3.0033,0,0,0,3-3V20h6A4.0045,4.0045,0,0,0,30,16ZM8,14H4V4H8Zm20,2a2.0025,2.0025,0,0,1-2,2H18v8a1.0008,1.0008,0,0,1-1,1H14.8672l-.9094-6.3662L10,14.6973V4H23a5.0057,5.0057,0,0,1,5,5Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ThumbsDown.propTypes = iconPropTypes;
}
var ThumbsDownFilled = /*#__PURE__*/React.forwardRef(function ThumbsDownFilled(_ref73, ref) {
  var children = _ref73.children,
      _ref73$size = _ref73.size,
      size = _ref73$size === void 0 ? 16 : _ref73$size,
      rest = _objectWithoutProperties(_ref73, _excluded73);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H7V16H2zM23 2H9V16.8027l3.0422 4.5635.8453 5.9165A2.0094 2.0094 0 0014.8672 29H15a3.0033 3.0033 0 003-3V20h8a4.0045 4.0045 0 004-4V9A7.0078 7.0078 0 0023 2z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ThumbsDownFilled.propTypes = iconPropTypes;
}
var ThumbsUp = /*#__PURE__*/React.forwardRef(function ThumbsUp(_ref74, ref) {
  var children = _ref74.children,
      _ref74$size = _ref74.size,
      size = _ref74$size === void 0 ? 16 : _ref74$size,
      rest = _objectWithoutProperties(_ref74, _excluded74);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M26,12H20V6a3.0033,3.0033,0,0,0-3-3H14.8672a2.0094,2.0094,0,0,0-1.98,1.7173l-.8453,5.9165L8.4648,16H2V30H23a7.0078,7.0078,0,0,0,7-7V16A4.0045,4.0045,0,0,0,26,12ZM8,28H4V18H8Zm20-5a5.0057,5.0057,0,0,1-5,5H10V17.3027l3.9578-5.9365L14.8672,5H17a1.0008,1.0008,0,0,1,1,1v8h8a2.0025,2.0025,0,0,1,2,2Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ThumbsUp.propTypes = iconPropTypes;
}
var ThumbsUpFilled = /*#__PURE__*/React.forwardRef(function ThumbsUpFilled(_ref75, ref) {
  var children = _ref75.children,
      _ref75$size = _ref75.size,
      size = _ref75$size === void 0 ? 16 : _ref75$size,
      rest = _objectWithoutProperties(_ref75, _excluded75);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16H7V30H2zM23 30H9V15.1973l3.0422-4.5635.8453-5.9165A2.0094 2.0094 0 0114.8672 3H15a3.0033 3.0033 0 013 3v6h8a4.0045 4.0045 0 014 4v7A7.0078 7.0078 0 0123 30z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ThumbsUpFilled.propTypes = iconPropTypes;
}
var Thunderstorm = /*#__PURE__*/React.forwardRef(function Thunderstorm(_ref76, ref) {
  var children = _ref76.children,
      _ref76$size = _ref76.size,
      size = _ref76$size === void 0 ? 16 : _ref76$size,
      rest = _objectWithoutProperties(_ref76, _excluded76);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M15.87 30.5L14.13 29.5 17.28 24 11.28 24 16.13 15.5 17.87 16.5 14.72 22 20.72 22 15.87 30.5z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Thunderstorm.propTypes = iconPropTypes;
}
var ThunderstormScattered = /*#__PURE__*/React.forwardRef(function ThunderstormScattered(_ref77, ref) {
  var children = _ref77.children,
      _ref77$size = _ref77.size,
      size = _ref77$size === void 0 ? 16 : _ref77$size,
      rest = _objectWithoutProperties(_ref77, _excluded77);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M13.338 30L11.602 29 13.889 25 10 25 13.993 18 15.73 19 13.446 23 17.337 23 13.338 30z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25V23a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23v2a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11Zm-4.0732,3.4893a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M26.732 16.233H29.732V18.233H26.732z",
    transform: "rotate(-135 28.232 17.233)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M29 10H32V12H29z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M26.732 3.768H29.732V5.768H26.732z",
    transform: "rotate(-45 28.232 4.768)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H22V3H20z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M12.268 3.768H15.268V5.768H12.268z",
    transform: "rotate(-135 13.768 4.768)"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ThunderstormScattered.propTypes = iconPropTypes;
}
var ThunderstormScatteredNight = /*#__PURE__*/React.forwardRef(function ThunderstormScatteredNight(_ref78, ref) {
  var children = _ref78.children,
      _ref78$size = _ref78.size,
      size = _ref78$size === void 0 ? 16 : _ref78$size,
      rest = _objectWithoutProperties(_ref78, _excluded78);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M13.338 30L11.602 29 13.889 25 10 25 13.993 18 15.73 19 13.446 23 17.337 23 13.338 30z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M29.844,13.0347a1.52,1.52,0,0,0-1.231-.8658,5.3562,5.3562,0,0,1-3.4094-1.7158A6.4652,6.4652,0,0,1,23.9187,4.06a1.6039,1.6039,0,0,0-.3-1.5459,1.4547,1.4547,0,0,0-1.3591-.4922l-.0191.0039a7.8544,7.8544,0,0,0-6.1054,6.48A7.3725,7.3725,0,0,0,13.5,8a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,25V23a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,23v2a5.9549,5.9549,0,0,0,5.88-7.1455,7.502,7.502,0,0,0,4.8669-3.3A1.537,1.537,0,0,0,29.844,13.0347Zm-5.6926,2.9179a5.9658,5.9658,0,0,0-3.502-2.7085A7.5084,7.5084,0,0,0,18.0288,9.55a6.0085,6.0085,0,0,1,3.77-5.3335,8.4582,8.4582,0,0,0,1.9392,7.5967A7.4037,7.4037,0,0,0,27.64,14.041,5.4419,5.4419,0,0,1,24.1514,15.9526Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ThunderstormScatteredNight.propTypes = iconPropTypes;
}
var ThunderstormSevere = /*#__PURE__*/React.forwardRef(function ThunderstormSevere(_ref79, ref) {
  var children = _ref79.children,
      _ref79$size = _ref79.size,
      size = _ref79$size === void 0 ? 16 : _ref79$size,
      rest = _objectWithoutProperties(_ref79, _excluded79);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7887.8947l-2 4A.9981.9981 0 0121 30zM9 32a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7887.8947l-2 4A.9981.9981 0 019 32zM15.901 30.496L14.165 29.504 17.309 24 11.31 24 16.165 15.504 17.901 16.496 14.756 22 20.757 22 15.901 30.496zM27.9516 15A4.399 4.399 0 0128 15.5 4.5049 4.5049 0 0123.5 20H23v2h.5A6.5075 6.5075 0 0030 15.5c0-.17-.0312-.333-.0444-.5z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M25.75,8h-1.5V4h1.5ZM25,9a1,1,0,1,0,1,1A1,1,0,0,0,25,9Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9115 11.9355L25.6283.3706a.7181.7181 0 00-1.2568 0L18.0883 11.9355A.72.72 0 0018.72 13H31.28A.72.72 0 0031.9115 11.9355zM24.25 4h1.5V8h-1.5zM25 11a1 1 0 111-1A1 1 0 0125 11zM8.144 11.019l.8154-.0639.0991-.812a6.9863 6.9863 0 019.97-5.45L20 2.9468A8.9777 8.9777 0 007.2 9.1362 6.4929 6.4929 0 007.43 21.9043L6.1059 24.5527a1 1 0 101.7885.8946l2-4a1 1 0 00-.4471-1.3418A.9786.9786 0 009 20.01V20H8.5a4.4975 4.4975 0 01-.3559-8.981z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ThunderstormSevere.propTypes = iconPropTypes;
}
var ThunderstormStrong = /*#__PURE__*/React.forwardRef(function ThunderstormStrong(_ref80, ref) {
  var children = _ref80.children,
      _ref80$size = _ref80.size,
      size = _ref80$size === void 0 ? 16 : _ref80$size,
      rest = _objectWithoutProperties(_ref80, _excluded80);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0121 30zM9 32a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 019 32zM15.901 30.496L14.165 29.504 17.31 24 11.31 24 16.165 15.504 17.901 16.496 14.756 22 20.757 22 15.901 30.496z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4929,6.4929,0,0,0,.23,12.7681L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418A.9786.9786,0,0,0,9,20.01V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20H23v2h.5A6.4974,6.4974,0,0,0,24.8008,9.1362Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ThunderstormStrong.propTypes = iconPropTypes;
}
var Ticket = /*#__PURE__*/React.forwardRef(function Ticket(_ref81, ref) {
  var children = _ref81.children,
      _ref81$size = _ref81.size,
      size = _ref81$size === void 0 ? 16 : _ref81$size,
      rest = _objectWithoutProperties(_ref81, _excluded81);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M29,14a1,1,0,0,0,1-1V8a2,2,0,0,0-2-2H4A2,2,0,0,0,2,8v5a1,1,0,0,0,1,1,2,2,0,0,1,0,4,1,1,0,0,0-1,1v5a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19a1,1,0,0,0-1-1,2,2,0,0,1,0-4Zm-1,5.87V24H21V21H19v3H4V19.87a4,4,0,0,0,0-7.74V8H19v3h2V8h7v4.13a4,4,0,0,0,0,7.74Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13H21V19H19z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Ticket.propTypes = iconPropTypes;
}
var Tides = /*#__PURE__*/React.forwardRef(function Tides(_ref82, ref) {
  var children = _ref82.children,
      _ref82$size = _ref82.size,
      size = _ref82$size === void 0 ? 16 : _ref82$size,
      rest = _objectWithoutProperties(_ref82, _excluded82);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7L9 2 4 7 5.413 8.416 8 5.833 8 14 10 14 10 5.833 12.586 8.414 14 7zM26.586 7.586L24 10.167 24 2 22 2 22 10.167 19.413 7.584 18 9 23 14 28 9 26.586 7.586zM20 20a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0016 17a.9894.9894 0 00-.9468.6787A3.44 3.44 0 0112 20a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 008 17a.971.971 0 00-.9468.6787A3.44 3.44 0 014 20H2v2H4a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0020 22H30V20zM28 28a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0024 25a.9894.9894 0 00-.9468.6787A3.44 3.44 0 0120 28a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0016 25a.971.971 0 00-.9468.6787A3.44 3.44 0 0112 28H2v2H12a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0028 30h2V28z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Tides.propTypes = iconPropTypes;
}
var Tif = /*#__PURE__*/React.forwardRef(function Tif(_ref83, ref) {
  var children = _ref83.children,
      _ref83$size = _ref83.size,
      size = _ref83$size === void 0 ? 16 : _ref83$size,
      rest = _objectWithoutProperties(_ref83, _excluded83);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM12 11L15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9 12 11zM2 11L5 11 5 23 7 23 7 11 10 11 10 9 2 9 2 11z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Tif.propTypes = iconPropTypes;
}
var Time = /*#__PURE__*/React.forwardRef(function Time(_ref84, ref) {
  var children = _ref84.children,
      _ref84$size = _ref84.size,
      size = _ref84$size === void 0 ? 16 : _ref84$size,
      rest = _objectWithoutProperties(_ref84, _excluded84);

  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor"
    }, rest), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
      d: "M10,19c-5,0-9-4-9-9s4-9,9-9s9,4,9,9S15,19,10,19z M10,2.3c-4.3,0-7.7,3.5-7.7,7.7s3.5,7.7,7.7,7.7s7.7-3.5,7.7-7.7 S14.3,2.3,10,2.3z"
    })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
      d: "M13 13.9L9.4 10.3 9.4 4 10.6 4 10.6 9.7 13.9 13z"
    })), children);
  }

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Time.propTypes = iconPropTypes;
}
var TimePlot = /*#__PURE__*/React.forwardRef(function TimePlot(_ref85, ref) {
  var children = _ref85.children,
      _ref85$size = _ref85.size,
      size = _ref85$size === void 0 ? 16 : _ref85$size,
      rest = _objectWithoutProperties(_ref85, _excluded85);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M23.586 13L21 10.414 21 6 23 6 23 9.586 25 11.586 23.586 13z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M22,18a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,22,18ZM22,4a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,22,4Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63,18l7,6H30V22H16.37l-7-6H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TimePlot.propTypes = iconPropTypes;
}
var Timer = /*#__PURE__*/React.forwardRef(function Timer(_ref86, ref) {
  var children = _ref86.children,
      _ref86$size = _ref86.size,
      size = _ref86$size === void 0 ? 16 : _ref86$size,
      rest = _objectWithoutProperties(_ref86, _excluded86);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11H17V20H15zM13 2H19V4H13z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M28,9,26.58,7.59,24.33,9.84a10.94,10.94,0,1,0,1.18,1.65ZM16,26a9,9,0,1,1,9-9A9,9,0,0,1,16,26Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Timer.propTypes = iconPropTypes;
}
var ToolBox = /*#__PURE__*/React.forwardRef(function ToolBox(_ref87, ref) {
  var children = _ref87.children,
      _ref87$size = _ref87.size,
      size = _ref87$size === void 0 ? 16 : _ref87$size,
      rest = _objectWithoutProperties(_ref87, _excluded87);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M27,9H24V6a2,2,0,0,0-2-2H10A2,2,0,0,0,8,6V9H5a3,3,0,0,0-3,3V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A3,3,0,0,0,27,9ZM10,6H22V9H10ZM28,26H4V17h8v5h8V17h8ZM14,17h4v3H14ZM4,15V12a1,1,0,0,1,1-1H27a1,1,0,0,1,1,1v3Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ToolBox.propTypes = iconPropTypes;
}
var ToolKit = /*#__PURE__*/React.forwardRef(function ToolKit(_ref88, ref) {
  var children = _ref88.children,
      _ref88$size = _ref88.size,
      size = _ref88$size === void 0 ? 16 : _ref88$size,
      rest = _objectWithoutProperties(_ref88, _excluded88);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9141,24.5l4.257-4.2568-1.414-1.4141L7.5,23.0859l-.793-.7929a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414l3,3a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414ZM5,28.5859,3.4141,27,6,24.4141,7.5859,26Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30a6.0067,6.0067,0,0,1-6-6,5.84,5.84,0,0,1,.2109-1.5469l-8.664-8.6638A5.8483,5.8483,0,0,1,8,14,5.9757,5.9757,0,0,1,2.4228,5.8164l.5577-1.4219L6.293,7.707a1.0233,1.0233,0,0,0,1.4135,0,.999.999,0,0,0,0-1.4141L4.3936,2.979l1.4233-.5571A5.9772,5.9772,0,0,1,14,8a5.84,5.84,0,0,1-.2109,1.5469l8.664,8.6635A5.8548,5.8548,0,0,1,24,18a5.9755,5.9755,0,0,1,5.5771,8.1836L29.02,27.6055,25.707,24.293a1.0233,1.0233,0,0,0-1.4135,0,.999.999,0,0,0-.0005,1.4141L27.6055,29.02l-1.4219.5579A5.96,5.96,0,0,1,24,30ZM10.0625,11.4763,20.5234,21.9375l-.2392.6094A3.9754,3.9754,0,0,0,23.75,27.9922l-.8711-.8711a2.9992,2.9992,0,0,1,0-4.2424,3.0721,3.0721,0,0,1,4.2427.0005l.8706.8708a3.9759,3.9759,0,0,0-5.4458-3.4658l-.6094.2385-10.46-10.46.2392-.6094A3.9755,3.9755,0,0,0,8.2505,4.0078l.8706.8711a2.9992,2.9992,0,0,1,0,4.2424,3.0721,3.0721,0,0,1-4.2427-.0005L4.0078,8.25a3.975,3.975,0,0,0,5.4453,3.4656Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1226,2.85a3.0716,3.0716,0,0,0-4.2422,0L17.4,10.33l1.4141,1.414,7.48-7.48a1.0244,1.0244,0,0,1,1.4141,0,1.002,1.002,0,0,1,0,1.4145l-7.48,7.48,1.414,1.4141,7.48-7.4795A3.0031,3.0031,0,0,0,29.1226,2.85Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ToolKit.propTypes = iconPropTypes;
}
var Tools = /*#__PURE__*/React.forwardRef(function Tools(_ref89, ref) {
  var children = _ref89.children,
      _ref89$size = _ref89.size,
      size = _ref89$size === void 0 ? 16 : _ref89$size,
      rest = _objectWithoutProperties(_ref89, _excluded89);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1,2A9.8,9.8,0,0,0,6.7,3.6L13.1,10a2.1,2.1,0,0,1,.2,3,2.1,2.1,0,0,1-3-.2L3.7,6.4A9.84,9.84,0,0,0,2,12.1,10.14,10.14,0,0,0,12.1,22.2a10.9,10.9,0,0,0,2.6-.3l6.7,6.7a5,5,0,0,0,7.1-7.1l-6.7-6.7a10.9,10.9,0,0,0,.3-2.6A10,10,0,0,0,12.1,2Zm8,10.1a7.61,7.61,0,0,1-.3,2.1l-.3,1.1.8.8L27,22.8a2.88,2.88,0,0,1,.9,2.1A2.72,2.72,0,0,1,27,27a2.9,2.9,0,0,1-4.2,0l-6.7-6.7-.8-.8-1.1.3a7.61,7.61,0,0,1-2.1.3,8.27,8.27,0,0,1-5.7-2.3A7.63,7.63,0,0,1,4,12.1a8.33,8.33,0,0,1,.3-2.2l4.4,4.4a4.14,4.14,0,0,0,5.9.2,4.14,4.14,0,0,0-.2-5.9L10,4.2a6.45,6.45,0,0,1,2-.3,8.27,8.27,0,0,1,5.7,2.3A8.49,8.49,0,0,1,20.1,12.1Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Tools.propTypes = iconPropTypes;
}
var ToolsAlt = /*#__PURE__*/React.forwardRef(function ToolsAlt(_ref90, ref) {
  var children = _ref90.children,
      _ref90$size = _ref90.size,
      size = _ref90$size === void 0 ? 16 : _ref90$size,
      rest = _objectWithoutProperties(_ref90, _excluded90);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1,16l6.3-6.3c0.8-0.8,0.8-2,0-2.8l-4.2-4.2c-0.8-0.8-2-0.8-2.8,0L16,8.9L9.7,2.6c-0.8-0.8-2-0.8-2.8,0L2.6,6.8 c-0.8,0.8-0.8,2,0,2.8L8.9,16L2,22.9V30h7.1l6.9-6.9l6.3,6.3c0.8,0.8,2,0.8,2.8,0l4.2-4.2c0.8-0.8,0.8-2,0-2.8L23.1,16z M23.8,4 L28,8.2l-6.3,6.3l-4.2-4.2L23.8,4z M8.2,28H4v-4.2l6.3-6.3l4.2,4.2L8.2,28z M23.8,28L4,8.2L8.2,4l3.5,3.5L9.6,9.6l1.4,1.4l2.1-2.1 l4.2,4.2l-2.1,2.1l1.4,1.4l2.1-2.1l4.2,4.2L21,20.9l1.4,1.4l2.1-2.1l3.5,3.5L23.8,28z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  ToolsAlt.propTypes = iconPropTypes;
}
var Tornado = /*#__PURE__*/React.forwardRef(function Tornado(_ref91, ref) {
  var children = _ref91.children,
      _ref91$size = _ref91.size,
      size = _ref91$size === void 0 ? 16 : _ref91$size,
      rest = _objectWithoutProperties(_ref91, _excluded91);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26H20V28H16zM12 22H18V24H12zM8 18H18V20H8zM8 14H20V16H8zM10 10H24V12H10zM8 6H26V8H8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Tornado.propTypes = iconPropTypes;
}
var TornadoWarning = /*#__PURE__*/React.forwardRef(function TornadoWarning(_ref92, ref) {
  var children = _ref92.children,
      _ref92$size = _ref92.size,
      size = _ref92$size === void 0 ? 16 : _ref92$size,
      rest = _objectWithoutProperties(_ref92, _excluded92);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4H18V6H2zM4 8H16V10H4zM2 12H14V14H2zM2 16H12V18H2zM4 20H12V22H4zM8 24H14V26H8zM12 28H16V30H12z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TornadoWarning.propTypes = iconPropTypes;
}
var Touch_1 = /*#__PURE__*/React.forwardRef(function Touch_1(_ref93, ref) {
  var children = _ref93.children,
      _ref93$size = _ref93.size,
      size = _ref93$size === void 0 ? 16 : _ref93$size,
      rest = _objectWithoutProperties(_ref93, _excluded93);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M20,8H18A5,5,0,0,0,8,8H6A7,7,0,0,1,20,8Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M25,15a2.94,2.94,0,0,0-1.47.4A3,3,0,0,0,21,14a2.94,2.94,0,0,0-1.47.4A3,3,0,0,0,16,13.18V8h0a3,3,0,0,0-6,0V19.1L7.77,17.58h0A2.93,2.93,0,0,0,6,17a3,3,0,0,0-2.12,5.13l8,7.3A6.16,6.16,0,0,0,16,31h5a7,7,0,0,0,7-7V18A3,3,0,0,0,25,15Zm1,9a5,5,0,0,1-5,5H16a4.17,4.17,0,0,1-2.76-1L5.29,20.7A1,1,0,0,1,5,20a1,1,0,0,1,1.6-.8L12,22.9V8a1,1,0,0,1,2,0h0V19h2V16a1,1,0,0,1,2,0v3h2V17a1,1,0,0,1,2,0v2h2V18a1,1,0,0,1,2,0Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Touch_1.propTypes = iconPropTypes;
}
var Touch_1Filled = /*#__PURE__*/React.forwardRef(function Touch_1Filled(_ref94, ref) {
  var children = _ref94.children,
      _ref94$size = _ref94.size,
      size = _ref94$size === void 0 ? 16 : _ref94$size,
      rest = _objectWithoutProperties(_ref94, _excluded94);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M13,2A6.0067,6.0067,0,0,0,7,8H9a4,4,0,0,1,8,0h2A6.0067,6.0067,0,0,0,13,2Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M21,30H16.5606a4,4,0,0,1-2.7088-1.0566L4.6513,20.4771A2.0018,2.0018,0,0,1,4.77,17.4219a2.0743,2.0743,0,0,1,2.6578.1728L11,20.8569V8a2,2,0,0,1,4,0v7a2,2,0,0,1,4,0v1a2,2,0,0,1,4,0v1a2,2,0,0,1,4,0v7A6,6,0,0,1,21,30Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Touch_1Filled.propTypes = iconPropTypes;
}
var Touch_1Down = /*#__PURE__*/React.forwardRef(function Touch_1Down(_ref95, ref) {
  var children = _ref95.children,
      _ref95$size = _ref95.size,
      size = _ref95$size === void 0 ? 16 : _ref95$size,
      rest = _objectWithoutProperties(_ref95, _excluded95);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M20,24H18A5,5,0,0,1,8,24H6a7,7,0,0,0,14,0Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M28,14V8a7.0085,7.0085,0,0,0-7-7H16a6.1457,6.1457,0,0,0-4.1055,1.5664L3.8833,9.874a2.9986,2.9986,0,0,0,3.881,4.55l.0008.0012L10,12.8955V24a3,3,0,0,0,6,0h0l0-5.1843a2.939,2.939,0,0,0,3.5294-1.2171A2.963,2.963,0,0,0,21,18a2.9936,2.9936,0,0,0,2.5292-1.4014A2.963,2.963,0,0,0,25,17,3.0033,3.0033,0,0,0,28,14Zm-2,0a1,1,0,0,1-2,0V13H22v2a1,1,0,0,1-2,0V13H18v3a1,1,0,0,1-2,0V13H14V24h.0005A1,1,0,0,1,12,24V9.1045L6.6,12.8008a.9993.9993,0,0,1-1.3081-1.5044l7.9507-7.2515A4.1483,4.1483,0,0,1,16,3h5a5.0059,5.0059,0,0,1,5,5Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Touch_1Down.propTypes = iconPropTypes;
}
var Touch_1DownFilled = /*#__PURE__*/React.forwardRef(function Touch_1DownFilled(_ref96, ref) {
  var children = _ref96.children,
      _ref96$size = _ref96.size,
      size = _ref96$size === void 0 ? 16 : _ref96$size,
      rest = _objectWithoutProperties(_ref96, _excluded96);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M13,30a6.0067,6.0067,0,0,1-6-6H9a4,4,0,0,0,8,0h2A6.0067,6.0067,0,0,1,13,30Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M21,2H16.5606a4,4,0,0,0-2.7088,1.0566L4.6513,11.5229A2.0018,2.0018,0,0,0,4.77,14.5781a2.0743,2.0743,0,0,0,2.6578-.1728L11,11.1431V24a2,2,0,0,0,4,0V17a2,2,0,0,0,4,0V16a2,2,0,0,0,4,0V15a2,2,0,0,0,4,0V8A6,6,0,0,0,21,2Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Touch_1DownFilled.propTypes = iconPropTypes;
}
var Touch_2 = /*#__PURE__*/React.forwardRef(function Touch_2(_ref97, ref) {
  var children = _ref97.children,
      _ref97$size = _ref97.size,
      size = _ref97$size === void 0 ? 16 : _ref97$size,
      rest = _objectWithoutProperties(_ref97, _excluded97);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M29,15H27A11,11,0,0,0,5,15H3a13,13,0,0,1,26,0Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M25,28H23V15A7,7,0,1,0,9,15V28H7V15a9,9,0,0,1,18,0Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M21,20H11V15a5,5,0,0,1,10,0Zm-8-2h6V15a3,3,0,0,0-6,0Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Touch_2.propTypes = iconPropTypes;
}
var Touch_2Filled = /*#__PURE__*/React.forwardRef(function Touch_2Filled(_ref98, ref) {
  var children = _ref98.children,
      _ref98$size = _ref98.size,
      size = _ref98$size === void 0 ? 16 : _ref98$size,
      rest = _objectWithoutProperties(_ref98, _excluded98);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a3.0033,3.0033,0,0,0-3,3v3h6V15A3.0033,3.0033,0,0,0,16,12Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6a9.0092,9.0092,0,0,0-9,9V28H25V15A9.01,9.01,0,0,0,16,6Zm5,14H11V15a5,5,0,0,1,10,0Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M29,15H27A11,11,0,0,0,5,15H3a13,13,0,0,1,26,0Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Touch_2Filled.propTypes = iconPropTypes;
}
var TouchInteraction = /*#__PURE__*/React.forwardRef(function TouchInteraction(_ref99, ref) {
  var children = _ref99.children,
      _ref99$size = _ref99.size,
      size = _ref99$size === void 0 ? 16 : _ref99$size,
      rest = _objectWithoutProperties(_ref99, _excluded99);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M26,21V20a1,1,0,0,1,2,0V30h2V20a3.0033,3.0033,0,0,0-3-3,2.964,2.964,0,0,0-1.4708.4014,2.9541,2.9541,0,0,0-4-1A2.9934,2.9934,0,0,0,19,15a2.96,2.96,0,0,0-1,.1846L18,10h0a3,3,0,0,0-6,0V21.1045L9.7651,19.5752l-.0008.001a2.999,2.999,0,0,0-3.881,4.55L12.3223,30l1.3479-1.478L7.2915,22.7036A.9908.9908,0,0,1,7,22a1.0005,1.0005,0,0,1,1.6-.8008L14,24.8955V10a1,1,0,0,1,2,0h0V21h2V18a1,1,0,0,1,2,0v3h2V19a1,1,0,0,1,2,0v2Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H22V10h6V4H4v6H8v2H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,12Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TouchInteraction.propTypes = iconPropTypes;
}
var TrafficEvent = /*#__PURE__*/React.forwardRef(function TrafficEvent(_ref100, ref) {
  var children = _ref100.children,
      _ref100$size = _ref100.size,
      size = _ref100$size === void 0 ? 16 : _ref100$size,
      rest = _objectWithoutProperties(_ref100, _excluded100);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21H17V23H11z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2456,8,25.96,14H30V12H27.4688l-1.3-4.5488A2.0077,2.0077,0,0,0,24.2456,6H22.8972l-.7287-2.5488A2.0077,2.0077,0,0,0,20.2456,2H7.7544A2.0078,2.0078,0,0,0,5.8315,3.4507L4.5312,8H2v2H6.04L7.7544,4H20.2456l.5715,2H11.7544A2.008,2.008,0,0,0,9.8315,7.45L8.8171,11H7.7144a1.9981,1.9981,0,0,0-1.8916,1.3516L4.5715,16H2v2H4v7a2.0025,2.0025,0,0,0,2,2v3H8V27H20v3h2V27a2.0025,2.0025,0,0,0,2-2V18h2V16H23.4287l-1.251-3.6475A1.9988,1.9988,0,0,0,20.2856,11H10.897l.8574-3ZM22,19v2H20v2h2v2H6V23H8V21H6V19Zm-.3429-2H6.3428l1.3716-4H20.2856Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TrafficEvent.propTypes = iconPropTypes;
}
var TrafficFlow = /*#__PURE__*/React.forwardRef(function TrafficFlow(_ref101, ref) {
  var children = _ref101.children,
      _ref101$size = _ref101.size,
      size = _ref101$size === void 0 ? 16 : _ref101$size,
      rest = _objectWithoutProperties(_ref101, _excluded101);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M26 8L22 4 18 8 19.41 9.42 21 7.83 21 18 23 18 23 7.83 24.58 9.41 26 8zM12.59 22.58L11 24.17 11 14 9 14 9 24.17 7.42 22.59 6 24 10 28 14 24 12.59 22.58zM2 2H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TrafficFlow.propTypes = iconPropTypes;
}
var TrafficFlowIncident = /*#__PURE__*/React.forwardRef(function TrafficFlowIncident(_ref102, ref) {
  var children = _ref102.children,
      _ref102$size = _ref102.size,
      size = _ref102$size === void 0 ? 16 : _ref102$size,
      rest = _objectWithoutProperties(_ref102, _excluded102);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M26 9.42L24.59 8 22.005 10.585 22 10.58 21.995 10.585 19.42 8.01 18 9.42 20.58 12 18 14.58 19.41 16 21.995 13.415 22 13.42 22.005 13.415 24.58 15.99 26 14.58 23.42 12 26 9.42zM14 17.42L12.59 16 10.005 18.585 10 18.58 9.995 18.585 7.42 16.01 6 17.42 8.58 20 6 22.58 7.41 24 9.995 21.415 10 21.42 10.005 21.415 12.58 23.99 14 22.58 11.42 20 14 17.42zM2 2H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TrafficFlowIncident.propTypes = iconPropTypes;
}
var TrafficIncident = /*#__PURE__*/React.forwardRef(function TrafficIncident(_ref103, ref) {
  var children = _ref103.children,
      _ref103$size = _ref103.size,
      size = _ref103$size === void 0 ? 16 : _ref103$size,
      rest = _objectWithoutProperties(_ref103, _excluded103);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M11.314 11.514H17.314V13.514H11.314z",
    transform: "rotate(-45 14.314 12.514)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0815,23.4329l4.1168,2.3176a2.009,2.009,0,0,0,2.3853-.3344l8.8326-8.8326a2.0088,2.0088,0,0,0,.334-2.3856l-2.2977-4.136,1.79-1.79L25.8283,6.8577,24.4141,8.2719l-4.95-4.95a2.0026,2.0026,0,0,0-2.8285,0L14.5146,1.2008,13.1,2.615l2.1213,2.1214L6.7364,13.2216,4.6151,11.1,3.2009,12.5145l2.1213,2.1213a2.0025,2.0025,0,0,0,0,2.8285l4.95,4.95L8.8577,23.8282l1.4143,1.4142Zm13.92-8.2636-8.8328,8.8328-4.5456-2.5255L23.4767,10.6235ZM9.5649,18.8785l1.4142-1.4142L9.5649,16.05,8.1506,17.4643,6.7364,16.05,18.05,4.7364l1.4143,1.4142L18.05,7.5648,19.4644,8.979l1.4142-1.4142L22.2928,8.979,10.9791,20.2927Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TrafficIncident.propTypes = iconPropTypes;
}
var TrafficWeatherIncident = /*#__PURE__*/React.forwardRef(function TrafficWeatherIncident(_ref104, ref) {
  var children = _ref104.children,
      _ref104$size = _ref104.size,
      size = _ref104$size === void 0 ? 16 : _ref104$size,
      rest = _objectWithoutProperties(_ref104, _excluded104);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M2 24H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15zM6 12A3.8978 3.8978 0 012 8.223a3.9017 3.9017 0 01.6533-2.0639L5.17 2.4141a1.0381 1.0381 0 011.6592 0L9.3154 6.11A3.9693 3.9693 0 0110 8.223 3.8978 3.8978 0 016 12zm0-7.2368L4.3438 7.2257A1.89 1.89 0 004 8.223a1.9007 1.9007 0 002 1.7775A1.9007 1.9007 0 008 8.223a1.98 1.98 0 00-.375-1.0466zM11 11.7627L9.3438 14.2253A1.89 1.89 0 009 15.2226 1.9007 1.9007 0 0011 17a1.9007 1.9007 0 002-1.7774 1.98 1.98 0 00-.375-1.0467zM6 15.7627L4.3438 18.2253A1.89 1.89 0 004 19.2226 1.9007 1.9007 0 006 21a1.9007 1.9007 0 002-1.7774 1.98 1.98 0 00-.375-1.0467z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TrafficWeatherIncident.propTypes = iconPropTypes;
}
var TrafficCone = /*#__PURE__*/React.forwardRef(function TrafficCone(_ref105, ref) {
  var children = _ref105.children,
      _ref105$size = _ref105.size,
      size = _ref105$size === void 0 ? 16 : _ref105$size,
      rest = _objectWithoutProperties(_ref105, _excluded105);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7957,28,18.9746,2.7754A1,1,0,0,0,18,2H14a1,1,0,0,0-.9746.7754L7.2043,28H4v2H28V28ZM19.9736,16H12.0264l.9229-4h6.1014Zm.4616,2,.923,4H10.6418l.923-4Zm-5.64-14h2.4092l1.3845,6H13.4109ZM10.18,24H21.82l.923,4H9.2573Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TrafficCone.propTypes = iconPropTypes;
}
var Train = /*#__PURE__*/React.forwardRef(function Train(_ref106, ref) {
  var children = _ref106.children,
      _ref106$size = _ref106.size,
      size = _ref106$size === void 0 ? 16 : _ref106$size,
      rest = _objectWithoutProperties(_ref106, _excluded106);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M21,3H11A5.0057,5.0057,0,0,0,6,8V20a4.99,4.99,0,0,0,3.582,4.77L7.7693,29H9.9451l1.7143-4h8.6812l1.7143,4h2.1758L22.418,24.77A4.99,4.99,0,0,0,26,20V8A5.0057,5.0057,0,0,0,21,3ZM11,5H21a2.9948,2.9948,0,0,1,2.8157,2H8.1843A2.9948,2.9948,0,0,1,11,5ZM24,19H21v2h2.8157A2.9948,2.9948,0,0,1,21,23H11a2.9948,2.9948,0,0,1-2.8157-2H11V19H8V17H24Zm0-4H8V9H24Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Train.propTypes = iconPropTypes;
}
var TrainHeart = /*#__PURE__*/React.forwardRef(function TrainHeart(_ref107, ref) {
  var children = _ref107.children,
      _ref107$size = _ref107.size,
      size = _ref107$size === void 0 ? 16 : _ref107$size,
      rest = _objectWithoutProperties(_ref107, _excluded107);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M27.303 2a2.6613 2.6613 0 00-1.9079.8059l-.3932.4053-.397-.4053a2.6612 2.6612 0 00-3.8157 0 2.7991 2.7991 0 000 3.8963L25.0019 11l4.2089-4.2978a2.7991 2.7991 0 000-3.8963A2.6613 2.6613 0 0027.303 2zM22 13v3H6V10h9V8H6.1843A2.9948 2.9948 0 019 6h6V4H9A5.0057 5.0057 0 004 9V21a4.99 4.99 0 003.582 4.77L5.7693 30H7.9451l1.7143-4h8.6812l1.7143 4h2.1758L20.418 25.77A4.99 4.99 0 0024 21V13zm0 7H19v2h2.8157A2.9948 2.9948 0 0119 24H9a2.9948 2.9948 0 01-2.8157-2H9V20H6V18H22z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TrainHeart.propTypes = iconPropTypes;
}
var TrainProfile = /*#__PURE__*/React.forwardRef(function TrainProfile(_ref108, ref) {
  var children = _ref108.children,
      _ref108$size = _ref108.size,
      size = _ref108$size === void 0 ? 16 : _ref108$size,
      rest = _objectWithoutProperties(_ref108, _excluded108);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25L2 25 2 27 4 27 4 29 6 29 6 27 11 27 11 29 13 29 13 27 18 27 18 29 20 29 20 27 25 27 25 29 27 29 27 27 30 27 30 25zM8 16H2V14H8V12H2V10H8a2.0021 2.0021 0 012 2v2A2.0021 2.0021 0 018 16z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M28.55,14.2305,19.97,6.3657A8.9775,8.9775,0,0,0,13.8882,4H2V6H12v4a2.0023,2.0023,0,0,0,2,2h9.1565l4.0417,3.7051A2.4723,2.4723,0,0,1,25.5273,20H2v2H25.5273a4.4726,4.4726,0,0,0,3.0225-7.77ZM14,10V6.0054A6.9774,6.9774,0,0,1,18.6182,7.84L20.9746,10Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TrainProfile.propTypes = iconPropTypes;
}
var TrainSpeed = /*#__PURE__*/React.forwardRef(function TrainSpeed(_ref109, ref) {
  var children = _ref109.children,
      _ref109$size = _ref109.size,
      size = _ref109$size === void 0 ? 16 : _ref109$size,
      rest = _objectWithoutProperties(_ref109, _excluded109);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25L2 25 2 27 4 27 4 29 6 29 6 27 11 27 11 29 13 29 13 27 18 27 18 29 20 29 20 27 25 27 25 29 27 29 27 27 30 27 30 25zM29.7144 16.59L18.1494 8.64A14.9327 14.9327 0 009.6519 6H2V8H9.6519a12.9459 12.9459 0 017.3647 2.2871L18.0532 11H9v2H20.9624l7.6187 5.2378A.966.966 0 0128.0342 20H2v2H28.0342a2.9661 2.9661 0 001.68-5.41z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TrainSpeed.propTypes = iconPropTypes;
}
var TrainTicket = /*#__PURE__*/React.forwardRef(function TrainTicket(_ref110, ref) {
  var children = _ref110.children,
      _ref110$size = _ref110.size,
      size = _ref110$size === void 0 ? 16 : _ref110$size,
      rest = _objectWithoutProperties(_ref110, _excluded110);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1257,7.125a1.125,1.125,0,1,1,0-2.25h.875V2h-12V4.875h.875a1.125,1.125,0,0,1,0,2.25h-.875V10h12V7.125Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0007,13v3h-16V10h9V8H6.185A2.9948,2.9948,0,0,1,9.0007,6h6V4h-6a5.0057,5.0057,0,0,0-5,5V21a4.99,4.99,0,0,0,3.582,4.77L5.77,30H7.9458L9.66,26h8.6812l1.7143,4h2.1758l-1.8127-4.23A4.99,4.99,0,0,0,24.0007,21V13Zm0,7h-3v2h2.8157a2.9948,2.9948,0,0,1-2.8157,2h-10A2.9948,2.9948,0,0,1,6.185,22H9.0007V20h-3V18h16Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TrainTicket.propTypes = iconPropTypes;
}
var TrainTime = /*#__PURE__*/React.forwardRef(function TrainTime(_ref111, ref) {
  var children = _ref111.children,
      _ref111$size = _ref111.size,
      size = _ref111$size === void 0 ? 16 : _ref111$size,
      rest = _objectWithoutProperties(_ref111, _excluded111);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M25.496 10.088L22.874 7.466 22.874 3 25.124 3 25.124 6.534 27.088 8.498 25.496 10.088z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M24,1a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,24,1Zm1.4971,9.0884L22.875,7.4658V3h2.25V6.5342l1.9639,1.9634Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M6,16V10h9V8H6.1843A2.9948,2.9948,0,0,1,9,6h6V4H9A5.0057,5.0057,0,0,0,4,9V21a4.99,4.99,0,0,0,3.582,4.77L5.7693,30H7.9451l1.7143-4h8.6812l1.7143,4h2.1758L20.418,25.77A4.99,4.99,0,0,0,24,21V16Zm16,4H19v2h2.8157A2.9948,2.9948,0,0,1,19,24H9a2.9948,2.9948,0,0,1-2.8157-2H9V20H6V18H22Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TrainTime.propTypes = iconPropTypes;
}
var Tram = /*#__PURE__*/React.forwardRef(function Tram(_ref112, ref) {
  var children = _ref112.children,
      _ref112$size = _ref112.size,
      size = _ref112$size === void 0 ? 16 : _ref112$size,
      rest = _objectWithoutProperties(_ref112, _excluded112);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M21,6H17V4h6V2H9V4h6V6H11a5.0057,5.0057,0,0,0-5,5V22a4.99,4.99,0,0,0,3.582,4.77L8.1978,30h2.1757l1.2859-3h8.6812l1.2859,3h2.1757L22.418,26.77A4.99,4.99,0,0,0,26,22V11A5.0057,5.0057,0,0,0,21,6ZM11,8H21a2.9948,2.9948,0,0,1,2.8157,2H8.1843A2.9948,2.9948,0,0,1,11,8ZM24,21H21v2h2.8157A2.9948,2.9948,0,0,1,21,25H11a2.9948,2.9948,0,0,1-2.8157-2H11V21H8V19H24Zm0-4H8V12H24Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Tram.propTypes = iconPropTypes;
}
var TransformBinary = /*#__PURE__*/React.forwardRef(function TransformBinary(_ref113, ref) {
  var children = _ref113.children,
      _ref113$size = _ref113.size,
      size = _ref113$size === void 0 ? 16 : _ref113$size,
      rest = _objectWithoutProperties(_ref113, _excluded113);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M23 20h-2c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v4C25 19.1 24.1 20 23 20zM21 14v4h2v-4H21zM15 12H17V20H15z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20H9c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v4C13 19.1 12.1 20 11 20zM9 14v4h2v-4H9zM16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TransformBinary.propTypes = iconPropTypes;
}
var TransformInstructions = /*#__PURE__*/React.forwardRef(function TransformInstructions(_ref114, ref) {
  var children = _ref114.children,
      _ref114$size = _ref114.size,
      size = _ref114$size === void 0 ? 16 : _ref114$size,
      rest = _objectWithoutProperties(_ref114, _excluded114);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V9h-2v2.1 c-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H9v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5l1.4,1.4 l1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V23h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8H23z M16,19 c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S17.7,19,16,19z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TransformInstructions.propTypes = iconPropTypes;
}
var TransformLanguage = /*#__PURE__*/React.forwardRef(function TransformLanguage(_ref115, ref) {
  var children = _ref115.children,
      _ref115$size = _ref115.size,
      size = _ref115$size === void 0 ? 16 : _ref115$size,
      rest = _objectWithoutProperties(_ref115, _excluded115);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19H18V21H10zM10 15H22V17H10zM10 11H22V13H10z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TransformLanguage.propTypes = iconPropTypes;
}
var Transgender = /*#__PURE__*/React.forwardRef(function Transgender(_ref116, ref) {
  var children = _ref116.children,
      _ref116$size = _ref116.size,
      size = _ref116$size === void 0 ? 16 : _ref116$size,
      rest = _objectWithoutProperties(_ref116, _excluded116);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M22,2V4h4.5859l-6.4016,6.4014a6.9474,6.9474,0,0,0-8.3686,0L10.4143,9,13,6.4141,11.5857,5,9,7.5859,5.4141,4H10V2H2v8H4V5.4141L7.5859,9,5,11.5854,6.4143,13,9,10.4141l1.4014,1.4013A6.9785,6.9785,0,0,0,15,22.92V25H11v2h4v3h2V27h4V25H17V22.92a6.9785,6.9785,0,0,0,4.5984-11.1045L28,5.4141V10h2V2ZM16,21a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,16,21Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Transgender.propTypes = iconPropTypes;
}
var Translate = /*#__PURE__*/React.forwardRef(function Translate(_ref117, ref) {
  var children = _ref117.children,
      _ref117$size = _ref117.size,
      size = _ref117$size === void 0 ? 16 : _ref117$size,
      rest = _objectWithoutProperties(_ref117, _excluded117);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M27.85 29H30L24 14H21.65l-6 15H17.8l1.6-4h6.85zM20.2 23l2.62-6.56L25.45 23zM18 7V5H11V2H9V5H2V7H12.74a14.71 14.71 0 01-3.19 6.18A13.5 13.5 0 017.26 9H5.16a16.47 16.47 0 003 5.58A16.84 16.84 0 013 18l.75 1.86A18.47 18.47 0 009.53 16a16.92 16.92 0 005.76 3.84L16 18a14.48 14.48 0 01-5.12-3.37A17.64 17.64 0 0014.8 7z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Translate.propTypes = iconPropTypes;
}
var TransmissionLte = /*#__PURE__*/React.forwardRef(function TransmissionLte(_ref118, ref) {
  var children = _ref118.children,
      _ref118$size = _ref118.size,
      size = _ref118$size === void 0 ? 16 : _ref118$size,
      rest = _objectWithoutProperties(_ref118, _excluded118);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M10.57 30l.9333-2h8.9928l.9333 2h2.2072L17 15.7778V11H15v4.7778L8.3631 30zM16 18.3647L17.6965 22h-3.393zM13.37 24h5.26l.9333 2H12.4369zM10.7832 9.3325a7.0007 7.0007 0 0110.4341 0l-1.49 1.334a5 5 0 00-7.4537 0z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1992,6.3994a11.0019,11.0019,0,0,1,17.6006,0L23.2,7.6a9.0009,9.0009,0,0,0-14.4014,0Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TransmissionLte.propTypes = iconPropTypes;
}
var Transpose = /*#__PURE__*/React.forwardRef(function Transpose(_ref119, ref) {
  var children = _ref119.children,
      _ref119$size = _ref119.size,
      size = _ref119$size === void 0 ? 16 : _ref119$size,
      rest = _objectWithoutProperties(_ref119, _excluded119);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26H14V24h5a5.0055 5.0055 0 005-5V14h2v5A7.0078 7.0078 0 0119 26zM8 30H4a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2H8a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 018 30zM4 14V28H8V14zM28 10H14a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V8A2.0023 2.0023 0 0128 10zM14 4V8H28V4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Transpose.propTypes = iconPropTypes;
}
var TrashCan = /*#__PURE__*/React.forwardRef(function TrashCan(_ref120, ref) {
  var children = _ref120.children,
      _ref120$size = _ref120.size,
      size = _ref120$size === void 0 ? 16 : _ref120$size,
      rest = _objectWithoutProperties(_ref120, _excluded120);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H14V24H12zM18 12H20V24H18z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6V8H6V28a2 2 0 002 2H24a2 2 0 002-2V8h2V6zM8 28V8H24V28zM12 2H20V4H12z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TrashCan.propTypes = iconPropTypes;
}
var Tree = /*#__PURE__*/React.forwardRef(function Tree(_ref121, ref) {
  var children = _ref121.children,
      _ref121$size = _ref121.size,
      size = _ref121$size === void 0 ? 16 : _ref121$size,
      rest = _objectWithoutProperties(_ref121, _excluded121);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H9V28h3V15.5664L8.4854,13.4575l1.0292-1.7148,3.5147,2.1084A2.0115,2.0115,0,0,1,14,15.5664V28A2.0023,2.0023,0,0,1,12,30Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H19a2.0024,2.0024,0,0,1-2-2V17h6a4.0008,4.0008,0,0,0,3.981-4.396A4.1489,4.1489,0,0,0,22.7853,9H21.2016L21.025,8.221C20.452,5.6961,18.0308,4,15,4A6.02,6.02,0,0,0,9.5585,7.4859L9.25,8.1531l-.863-.1143A2.771,2.771,0,0,0,8,8a4,4,0,1,0,0,8v2A6,6,0,1,1,8,6c.0264,0,.0525,0,.0786.001A8.0271,8.0271,0,0,1,15,2c3.6788,0,6.6923,1.9776,7.7516,5h.0337a6.1641,6.1641,0,0,1,6.1872,5.4141A6.0011,6.0011,0,0,1,23,19l-4,0v9h3Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Tree.propTypes = iconPropTypes;
}
var TreeFallRisk = /*#__PURE__*/React.forwardRef(function TreeFallRisk(_ref122, ref) {
  var children = _ref122.children,
      _ref122$size = _ref122.size,
      size = _ref122$size === void 0 ? 16 : _ref122$size,
      rest = _objectWithoutProperties(_ref122, _excluded122);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z",
    "data-icon-path": "inner-path"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9115 13.9355L23.6284 2.3706a.7181.7181 0 00-1.2568 0L16.0885 13.9355A.72.72 0 0016.72 15H29.28A.72.72 0 0029.9115 13.9355zM22.25 6h1.5v4h-1.5zM23 13a1 1 0 111-1A1 1 0 0123 13zM26 19V17H17V28a2.0027 2.0027 0 002 2h3V28H19V19zM12 30H9V28h3V15.5664L8.4854 13.4575l1.0292-1.7148 3.5147 2.1084A2.0115 2.0115 0 0114 15.5664V28A2.0024 2.0024 0 0112 30z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6638,5.0059l.96-1.7671A8.9324,8.9324,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4,6.8916,6.8916,0,0,1,18.6638,5.0059Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TreeFallRisk.propTypes = iconPropTypes;
}
var TreeView = /*#__PURE__*/React.forwardRef(function TreeView(_ref123, ref) {
  var children = _ref123.children,
      _ref123$size = _ref123.size,
      size = _ref123$size === void 0 ? 16 : _ref123$size,
      rest = _objectWithoutProperties(_ref123, _excluded123);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M30,20V12H22v3H17V7a2,2,0,0,0-2-2H10V2H2v8h8V7h5V25a2,2,0,0,0,2,2h5v3h8V22H22v3H17V17h5v3ZM8,8H4V4H8ZM24,24h4v4H24Zm0-10h4v4H24Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TreeView.propTypes = iconPropTypes;
}
var TreeViewAlt = /*#__PURE__*/React.forwardRef(function TreeViewAlt(_ref124, ref) {
  var children = _ref124.children,
      _ref124$size = _ref124.size,
      size = _ref124$size === void 0 ? 16 : _ref124$size,
      rest = _objectWithoutProperties(_ref124, _excluded124);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M23,9h6a2,2,0,0,0,2-2V3a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2V4H11V3A2,2,0,0,0,9,1H3A2,2,0,0,0,1,3V7A2,2,0,0,0,3,9H9a2,2,0,0,0,2-2V6h4V26a2.0023,2.0023,0,0,0,2,2h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V25a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V17h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V14a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V6h4V7A2,2,0,0,0,23,9Zm0-6h6V7H23ZM9,7H3V3H9ZM23,25h6v4H23Zm0-11h6v4H23Z",
    transform: "translate(0 .005)"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  TreeViewAlt.propTypes = iconPropTypes;
}
var Trophy = /*#__PURE__*/React.forwardRef(function Trophy(_ref125, ref) {
  var children = _ref125.children,
      _ref125$size = _ref125.size,
      size = _ref125$size === void 0 ? 16 : _ref125$size,
      rest = _objectWithoutProperties(_ref125, _excluded125);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm14,0a6,6,0,0,1-6.1855,5.9971A6.1991,6.1991,0,0,1,10,13.7065V6H22Zm4-2a2.0023,2.0023,0,0,1-2,2V9h2Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Trophy.propTypes = iconPropTypes;
}

export { TaskLocation, TaskRemove, TaskSettings, TaskStar, TaskTools, TaskView, Taste, Taxi, TcpIpService, Temperature, TemperatureCelsius, TemperatureCelsiusAlt, TemperatureFahrenheit, TemperatureFahrenheitAlt, TemperatureFeelsLike, TemperatureFrigid, TemperatureHot, TemperatureInversion, TemperatureMax, TemperatureMin, TemperatureWater, Template, Tennis, TennisBall, Term, Terminal, Terminal_3270, TestTool, TextAlignCenter, TextAlignJustify, TextAlignLeft, TextAlignMixed, TextAlignRight, TextAllCaps, TextBold, TextClearFormat, TextColor, TextCreation, TextFill, TextFont, TextFootnote, TextHighlight, TextIndent, TextIndentLess, TextIndentMore, TextItalic, TextKerning, TextLeading, TextLineSpacing, TextLink, TextLinkAnalysis, TextMining, TextMiningApplier, TextNewLine, TextScale, TextSelection, TextSmallCaps, TextStrikethrough, TextSubscript, TextSuperscript, TextTracking, TextUnderline, TextVerticalAlignment, TextWrap, Theater, ThisSideUp, Thumbnail_1, Thumbnail_2, ThumbsDown, ThumbsDownFilled, ThumbsUp, ThumbsUpFilled, Thunderstorm, ThunderstormScattered, ThunderstormScatteredNight, ThunderstormSevere, ThunderstormStrong, Ticket, Tides, Tif, Time, TimePlot, Timer, ToolBox, ToolKit, Tools, ToolsAlt, Tornado, TornadoWarning, TouchInteraction, Touch_1, Touch_1Down, Touch_1DownFilled, Touch_1Filled, Touch_2, Touch_2Filled, TrafficCone, TrafficEvent, TrafficFlow, TrafficFlowIncident, TrafficIncident, TrafficWeatherIncident, Train, TrainHeart, TrainProfile, TrainSpeed, TrainTicket, TrainTime, Tram, TransformBinary, TransformInstructions, TransformLanguage, Transgender, Translate, TransmissionLte, Transpose, TrashCan, Tree, TreeFallRisk, TreeView, TreeViewAlt, Trophy, WatsonHealthTextAnnotationToggle, WatsonHealthThreshold, WatsonHealthThumbnailPreview };
